import { FC, SVGProps } from 'react'

interface IconProps extends SVGProps<SVGSVGElement> {
  height?: string
  width?: string
}

const IconWrapper: FC<IconProps> = ({
  height = 56,
  width = 56,
  children,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    enableBackground="new 0 0 56 56"
    {...rest}
  >
    {children}
  </svg>
)

const ExeFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g>
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#9777a8' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M17.082,44.168v3.172h4.211v1.121h-4.211v3.295h4.635V53h-6.303V42.924h6.303v1.244H17.082z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M28.58,48.105L31.137,53h-1.9l-1.6-3.801H27.5L25.777,53h-1.9l2.557-4.895l-2.721-5.182h1.873 l1.777,4.102H27.5l1.928-4.102h1.873L28.58,48.105z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M35.266,44.168v3.172h4.211v1.121h-4.211v3.295H39.9V53h-6.303V42.924H39.9v1.244H35.266z"
        />
      </g>
      <path
        style={{ fill: '#9777a8' }}
        d="M33.5,32c-0.099,0-0.2-0.015-0.299-0.046c-0.527-0.165-0.821-0.726-0.656-1.253l5-16 c0.165-0.527,0.726-0.821,1.253-0.656c0.527,0.165,0.821,0.726,0.656,1.253l-5,16C34.321,31.726,33.926,32,33.5,32z"
      />
      <circle style={{ fill: '#9777a8' }} cx="29" cy="19.5" r="1.5" />
      <circle style={{ fill: '#9777a8' }} cx="29" cy="26.5" r="1.5" />
      <path
        style={{ fill: '#9777a8' }}
        d="M23.5,30h-2c-3.86,0-7-3.14-7-7s3.14-7,7-7h2c0.552,0,1,0.448,1,1s-0.448,1-1,1h-2 c-2.757,0-5,2.243-5,5s2.243,5,5,5h2c0.552,0,1,0.448,1,1S24.052,30,23.5,30z"
      />
    </g>
  </IconWrapper>
)

const DbfFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#e96360' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M22.947,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937 s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C18.95,52.984,18.754,53,18.627,53h-3.814V42.924h3.035 c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C22.842,46.494,22.947,47.08,22.947,47.682z M18.08,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244 c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H18.08z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M30.098,47.695c0.209,0.027,0.433,0.096,0.67,0.205c0.237,0.109,0.458,0.265,0.663,0.465 s0.376,0.444,0.513,0.731s0.205,0.617,0.205,0.991c0,0.456-0.068,0.848-0.205,1.176s-0.308,0.6-0.513,0.813 s-0.429,0.383-0.67,0.506c-0.242,0.123-0.474,0.217-0.697,0.28c-0.224,0.063-0.422,0.103-0.595,0.116 C29.295,52.993,29.182,53,29.127,53H25.34V42.924h2.898c0.428,0,0.843,0.05,1.244,0.15c0.401,0.101,0.756,0.26,1.066,0.479 c0.31,0.219,0.556,0.504,0.738,0.854c0.182,0.351,0.273,0.768,0.273,1.251c0,0.282-0.046,0.54-0.137,0.772 c-0.091,0.232-0.205,0.436-0.342,0.608s-0.294,0.316-0.472,0.431S30.262,47.659,30.098,47.695z M28.197,47.23 c0.2,0,0.405-0.005,0.615-0.014c0.209-0.009,0.405-0.06,0.588-0.15c0.182-0.091,0.33-0.246,0.444-0.465 c0.114-0.219,0.171-0.533,0.171-0.943c0-0.164-0.023-0.335-0.068-0.513c-0.046-0.178-0.137-0.34-0.273-0.485 s-0.333-0.265-0.588-0.355c-0.255-0.091-0.593-0.137-1.012-0.137H26.98v3.063h0.068H28.197z M29.031,51.797 c0.483,0,0.861-0.155,1.135-0.465s0.41-0.725,0.41-1.244c0-0.492-0.142-0.907-0.424-1.244c-0.283-0.337-0.697-0.506-1.244-0.506 H26.98v3.459H29.031z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M36.168,44.168v3.172h4.211v1.121h-4.211V53H34.5V42.924h6.303v1.244H36.168z"
        />
      </g>
      <path
        style={{ fill: '#c8bdb8' }}
        d="M24.5,16v-4h-12v4v2v2v2v2v2v2v2v4h10h2h21v-4v-2v-2v-2v-2v-2v-4H24.5z M14.5,14h8v2h-8V14z M14.5,18h8v2h-8V18z M14.5,22h8v2h-8V22z M14.5,26h8v2h-8V26z M22.5,32h-8v-2h8V32z M43.5,32h-19v-2h19V32z M43.5,28h-19v-2h19V28 z M43.5,24h-19v-2h19V24z M24.5,20v-2h19v2H24.5z"
      />
    </g>
  </IconWrapper>
)

const XmlFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#f29c1f' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M19.379,48.105L21.936,53h-1.9l-1.6-3.801h-0.137L16.576,53h-1.9l2.557-4.895l-2.721-5.182h1.873 l1.777,4.102h0.137l1.928-4.102H22.1L19.379,48.105z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M31.998,42.924h1.668V53h-1.668v-6.932l-2.256,5.605h-1.449l-2.27-5.605V53h-1.668V42.924h1.668 l2.994,6.891L31.998,42.924z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M37.863,42.924v8.832h4.635V53h-6.303V42.924H37.863z"
        />
      </g>
      <path
        style={{ fill: '#f29c1f' }}
        d="M15.5,24c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l6-6 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-6,6C16.012,23.902,15.756,24,15.5,24z"
      />
      <path
        style={{ fill: '#f29c1f' }}
        d="M21.5,30c-0.256,0-0.512-0.098-0.707-0.293l-6-6c-0.391-0.391-0.391-1.023,0-1.414 s1.023-0.391,1.414,0l6,6c0.391,0.391,0.391,1.023,0,1.414C22.012,29.902,21.756,30,21.5,30z"
      />
      <path
        style={{ fill: '#f29c1f' }}
        d="M33.5,30c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l6-6 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-6,6C34.012,29.902,33.756,30,33.5,30z"
      />
      <path
        style={{ fill: '#f29c1f' }}
        d="M39.5,24c-0.256,0-0.512-0.098-0.707-0.293l-6-6c-0.391-0.391-0.391-1.023,0-1.414 s1.023-0.391,1.414,0l6,6c0.391,0.391,0.391,1.023,0,1.414C40.012,23.902,39.756,24,39.5,24z"
      />
      <path
        style={{ fill: '#f29c1f' }}
        d="M24.5,32c-0.11,0-0.223-0.019-0.333-0.058c-0.521-0.184-0.794-0.755-0.61-1.276l6-17 c0.185-0.521,0.753-0.795,1.276-0.61c0.521,0.184,0.794,0.755,0.61,1.276l-6,17C25.298,31.744,24.912,32,24.5,32z"
      />
    </g>
  </IconWrapper>
)

const JsFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#eeaf4b' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M26.021,42.719v7.848c0,0.474-0.087,0.873-0.26,1.196c-0.174,0.323-0.406,0.583-0.697,0.779 c-0.292,0.196-0.627,0.333-1.005,0.41s-0.769,0.116-1.169,0.116c-0.201,0-0.436-0.021-0.704-0.062s-0.547-0.104-0.834-0.191 s-0.563-0.185-0.827-0.294c-0.265-0.109-0.488-0.232-0.67-0.369l0.697-1.107c0.091,0.063,0.221,0.13,0.39,0.198 s0.353,0.132,0.554,0.191c0.2,0.06,0.41,0.111,0.629,0.157s0.424,0.068,0.615,0.068c0.482,0,0.868-0.094,1.155-0.28 s0.439-0.504,0.458-0.95v-7.711H26.021z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M34.184,50.238c0,0.364-0.075,0.718-0.226,1.06s-0.362,0.643-0.636,0.902s-0.611,0.467-1.012,0.622 c-0.401,0.155-0.857,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.468-0.062-0.704-0.116 c-0.237-0.055-0.463-0.13-0.677-0.226s-0.399-0.212-0.554-0.349l0.287-1.176c0.127,0.073,0.289,0.144,0.485,0.212 s0.398,0.132,0.608,0.191c0.209,0.06,0.419,0.107,0.629,0.144c0.209,0.036,0.405,0.055,0.588,0.055c0.556,0,0.982-0.13,1.278-0.39 s0.444-0.645,0.444-1.155c0-0.31-0.105-0.574-0.314-0.793c-0.21-0.219-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533 c-0.365-0.178-0.707-0.388-1.025-0.629c-0.319-0.241-0.584-0.526-0.793-0.854c-0.21-0.328-0.314-0.738-0.314-1.23 c0-0.446,0.082-0.843,0.246-1.189s0.385-0.641,0.663-0.882s0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191 c0.419,0,0.843,0.039,1.271,0.116c0.428,0.077,0.774,0.203,1.039,0.376c-0.055,0.118-0.119,0.248-0.191,0.39 c-0.073,0.142-0.142,0.273-0.205,0.396c-0.064,0.123-0.119,0.226-0.164,0.308c-0.046,0.082-0.073,0.128-0.082,0.137 c-0.055-0.027-0.116-0.063-0.185-0.109s-0.167-0.091-0.294-0.137c-0.128-0.046-0.297-0.077-0.506-0.096 c-0.21-0.019-0.479-0.014-0.807,0.014c-0.183,0.019-0.355,0.07-0.52,0.157s-0.311,0.193-0.438,0.321 c-0.128,0.128-0.229,0.271-0.301,0.431c-0.073,0.159-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882 c0.209,0.224,0.469,0.419,0.779,0.588c0.31,0.169,0.646,0.333,1.012,0.492c0.364,0.159,0.704,0.354,1.019,0.581 s0.576,0.513,0.786,0.854C34.078,49.261,34.184,49.7,34.184,50.238z"
        />
      </g>
      <g>
        <path
          style={{ fill: '#eeaf4b' }}
          d="M19.5,19v-4c0-0.551,0.448-1,1-1c0.553,0,1-0.448,1-1s-0.447-1-1-1c-1.654,0-3,1.346-3,3v4 c0,1.103-0.897,2-2,2c-0.553,0-1,0.448-1,1s0.447,1,1,1c1.103,0,2,0.897,2,2v4c0,1.654,1.346,3,3,3c0.553,0,1-0.448,1-1 s-0.447-1-1-1c-0.552,0-1-0.449-1-1v-4c0-1.2-0.542-2.266-1.382-3C18.958,21.266,19.5,20.2,19.5,19z"
        />
        <circle style={{ fill: '#eeaf4b' }} cx="27.5" cy="18.5" r="1.5" />
        <path
          style={{ fill: '#eeaf4b' }}
          d="M39.5,21c-1.103,0-2-0.897-2-2v-4c0-1.654-1.346-3-3-3c-0.553,0-1,0.448-1,1s0.447,1,1,1 c0.552,0,1,0.449,1,1v4c0,1.2,0.542,2.266,1.382,3c-0.84,0.734-1.382,1.8-1.382,3v4c0,0.551-0.448,1-1,1c-0.553,0-1,0.448-1,1 s0.447,1,1,1c1.654,0,3-1.346,3-3v-4c0-1.103,0.897-2,2-2c0.553,0,1-0.448,1-1S40.053,21,39.5,21z"
        />
        <path
          style={{ fill: '#eeaf4b' }}
          d="M27.5,24c-0.553,0-1,0.448-1,1v3c0,0.552,0.447,1,1,1s1-0.448,1-1v-3 C28.5,24.448,28.053,24,27.5,24z"
        />
      </g>
    </g>
  </IconWrapper>
)

const JsonFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#9777a8' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M17.021,42.719v7.848c0,0.474-0.087,0.873-0.26,1.196s-0.405,0.583-0.697,0.779 s-0.627,0.333-1.005,0.41c-0.378,0.077-0.768,0.116-1.169,0.116c-0.2,0-0.436-0.021-0.704-0.062s-0.547-0.104-0.834-0.191 s-0.563-0.185-0.827-0.294s-0.487-0.232-0.67-0.369l0.697-1.107c0.091,0.063,0.221,0.13,0.39,0.198s0.354,0.132,0.554,0.191 s0.41,0.111,0.629,0.157s0.424,0.068,0.615,0.068c0.483,0,0.868-0.094,1.155-0.28s0.439-0.504,0.458-0.95v-7.711H17.021z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M25.184,50.238c0,0.364-0.075,0.718-0.226,1.06s-0.362,0.643-0.636,0.902s-0.61,0.467-1.012,0.622 s-0.856,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116c-0.237-0.055-0.463-0.13-0.677-0.226 s-0.398-0.212-0.554-0.349l0.287-1.176c0.128,0.073,0.289,0.144,0.485,0.212s0.398,0.132,0.608,0.191s0.419,0.107,0.629,0.144 s0.405,0.055,0.588,0.055c0.556,0,0.982-0.13,1.278-0.39s0.444-0.645,0.444-1.155c0-0.31-0.104-0.574-0.314-0.793 s-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533s-0.706-0.388-1.025-0.629s-0.583-0.526-0.793-0.854s-0.314-0.738-0.314-1.23 c0-0.446,0.082-0.843,0.246-1.189s0.385-0.641,0.663-0.882s0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191 c0.419,0,0.843,0.039,1.271,0.116s0.774,0.203,1.039,0.376c-0.055,0.118-0.118,0.248-0.191,0.39s-0.142,0.273-0.205,0.396 s-0.118,0.226-0.164,0.308s-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109s-0.166-0.091-0.294-0.137 s-0.296-0.077-0.506-0.096s-0.479-0.014-0.807,0.014c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321 s-0.228,0.271-0.301,0.431s-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882s0.47,0.419,0.779,0.588 s0.647,0.333,1.012,0.492s0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854S25.184,49.7,25.184,50.238z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M35.082,47.914c0,0.848-0.107,1.595-0.321,2.242s-0.511,1.185-0.889,1.613s-0.82,0.752-1.326,0.971 s-1.06,0.328-1.661,0.328s-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971s-0.675-0.966-0.889-1.613s-0.321-1.395-0.321-2.242 s0.107-1.593,0.321-2.235s0.511-1.178,0.889-1.606s0.82-0.754,1.326-0.978s1.06-0.335,1.661-0.335s1.155,0.111,1.661,0.335 s0.948,0.549,1.326,0.978s0.675,0.964,0.889,1.606S35.082,47.066,35.082,47.914z M30.844,51.729c0.337,0,0.658-0.066,0.964-0.198 s0.579-0.349,0.82-0.649s0.431-0.695,0.567-1.183s0.21-1.082,0.219-1.784c-0.009-0.684-0.08-1.265-0.212-1.743 s-0.314-0.873-0.547-1.183s-0.497-0.533-0.793-0.67s-0.608-0.205-0.937-0.205c-0.337,0-0.658,0.063-0.964,0.191 s-0.579,0.344-0.82,0.649s-0.431,0.699-0.567,1.183c-0.137,0.483-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75 s0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67S30.516,51.729,30.844,51.729z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M44.68,42.924V53h-1.668l-3.951-6.945V53h-1.668V42.924h1.668l3.951,6.945v-6.945H44.68z"
        />
      </g>
      <g>
        <path
          style={{ fill: '#9777a8' }}
          d="M19.5,19v-4c0-0.551,0.448-1,1-1c0.553,0,1-0.448,1-1s-0.447-1-1-1c-1.654,0-3,1.346-3,3v4 c0,1.103-0.897,2-2,2c-0.553,0-1,0.448-1,1s0.447,1,1,1c1.103,0,2,0.897,2,2v4c0,1.654,1.346,3,3,3c0.553,0,1-0.448,1-1 s-0.447-1-1-1c-0.552,0-1-0.449-1-1v-4c0-1.2-0.542-2.266-1.382-3C18.958,21.266,19.5,20.2,19.5,19z"
        />
        <circle style={{ fill: '#9777a8' }} cx="27.5" cy="18.5" r="1.5" />
        <path
          style={{ fill: '#9777a8' }}
          d="M39.5,21c-1.103,0-2-0.897-2-2v-4c0-1.654-1.346-3-3-3c-0.553,0-1,0.448-1,1s0.447,1,1,1 c0.552,0,1,0.449,1,1v4c0,1.2,0.542,2.266,1.382,3c-0.84,0.734-1.382,1.8-1.382,3v4c0,0.551-0.448,1-1,1c-0.553,0-1,0.448-1,1 s0.447,1,1,1c1.654,0,3-1.346,3-3v-4c0-1.103,0.897-2,2-2c0.553,0,1-0.448,1-1S40.053,21,39.5,21z"
        />
        <path
          style={{ fill: '#9777a8' }}
          d="M27.5,24c-0.553,0-1,0.448-1,1v3c0,0.552,0.447,1,1,1s1-0.448,1-1v-3 C28.5,24.448,28.053,24,27.5,24z"
        />
      </g>
    </g>
  </IconWrapper>
)

const HtmlFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#ec6630' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M17.455,42.924V53h-1.641v-4.539h-4.361V53H9.785V42.924h1.668v4.416h4.361v-4.416H17.455z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M27.107,42.924v1.121H24.1V53h-1.654v-8.955h-3.008v-1.121H27.107z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M36.705,42.924h1.668V53h-1.668v-6.932l-2.256,5.605H33l-2.27-5.605V53h-1.668V42.924h1.668 l2.994,6.891L36.705,42.924z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M42.57,42.924v8.832h4.635V53h-6.303V42.924H42.57z"
        />
      </g>
      <g>
        <path
          style={{ fill: '#ec6630' }}
          d="M23.207,16.293c-0.391-0.391-1.023-0.391-1.414,0l-6,6c-0.391,0.391-0.391,1.023,0,1.414l6,6 C21.988,29.902,22.244,30,22.5,30s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L17.914,23l5.293-5.293 C23.598,17.316,23.598,16.684,23.207,16.293z"
        />
        <path
          style={{ fill: '#ec6630' }}
          d="M41.207,22.293l-6-6c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L39.086,23 l-5.293,5.293c-0.391,0.391-0.391,1.023,0,1.414C33.988,29.902,34.244,30,34.5,30s0.512-0.098,0.707-0.293l6-6 C41.598,23.316,41.598,22.684,41.207,22.293z"
        />
      </g>
    </g>
  </IconWrapper>
)

const CsvFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#f36fa0' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M21.58,51.975c-0.374,0.364-0.798,0.638-1.271,0.82c-0.474,0.183-0.984,0.273-1.531,0.273 c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971c-0.378-0.429-0.675-0.966-0.889-1.613 c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235c0.214-0.643,0.51-1.178,0.889-1.606 c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335c0.547,0,1.057,0.091,1.531,0.273 c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.228-0.265-0.481-0.456-0.759-0.574c-0.278-0.118-0.567-0.178-0.868-0.178 c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649c-0.242,0.306-0.431,0.699-0.567,1.183 s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67 c0.296,0.142,0.608,0.212,0.937,0.212s0.636-0.06,0.923-0.178s0.549-0.31,0.786-0.574L21.58,51.975z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M29.633,50.238c0,0.364-0.075,0.718-0.226,1.06s-0.362,0.643-0.636,0.902s-0.611,0.467-1.012,0.622 c-0.401,0.155-0.857,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116 c-0.237-0.055-0.463-0.13-0.677-0.226c-0.214-0.096-0.399-0.212-0.554-0.349l0.287-1.176c0.127,0.073,0.289,0.144,0.485,0.212 c0.196,0.068,0.398,0.132,0.608,0.191c0.209,0.06,0.419,0.107,0.629,0.144c0.209,0.036,0.405,0.055,0.588,0.055 c0.556,0,0.982-0.13,1.278-0.39c0.296-0.26,0.444-0.645,0.444-1.155c0-0.31-0.105-0.574-0.314-0.793 c-0.21-0.219-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533c-0.365-0.178-0.707-0.388-1.025-0.629 c-0.319-0.241-0.583-0.526-0.793-0.854c-0.21-0.328-0.314-0.738-0.314-1.23c0-0.446,0.082-0.843,0.246-1.189 s0.385-0.641,0.663-0.882c0.278-0.241,0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191c0.419,0,0.843,0.039,1.271,0.116 c0.428,0.077,0.774,0.203,1.039,0.376c-0.055,0.118-0.119,0.248-0.191,0.39c-0.073,0.142-0.142,0.273-0.205,0.396 c-0.064,0.123-0.119,0.226-0.164,0.308c-0.046,0.082-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109 s-0.167-0.091-0.294-0.137c-0.128-0.046-0.296-0.077-0.506-0.096c-0.21-0.019-0.479-0.014-0.807,0.014 c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321c-0.128,0.128-0.228,0.271-0.301,0.431 c-0.073,0.159-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882c0.209,0.224,0.469,0.419,0.779,0.588 c0.31,0.169,0.647,0.333,1.012,0.492c0.364,0.159,0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854 C29.528,49.261,29.633,49.7,29.633,50.238z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M34.035,53.055l-3.131-10.131h1.873l2.338,8.695l2.475-8.695h1.859l-3.281,10.131H34.035z"
        />
      </g>
      <path
        style={{ fill: '#c8bdb8' }}
        d="M23.5,16v-4h-12v4v2v2v2v2v2v2v2v4h10h2h21v-4v-2v-2v-2v-2v-2v-4H23.5z M13.5,14h8v2h-8V14z M13.5,18h8v2h-8V18z M13.5,22h8v2h-8V22z M13.5,26h8v2h-8V26z M21.5,32h-8v-2h8V32z M42.5,32h-19v-2h19V32z M42.5,28h-19v-2h19V28 z M42.5,24h-19v-2h19V24z M23.5,20v-2h19v2H23.5z"
      />
    </g>
  </IconWrapper>
)

const CssFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#0096e6' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M23.58,51.975c-0.374,0.364-0.798,0.638-1.271,0.82s-0.984,0.273-1.531,0.273 c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971s-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242 s0.107-1.593,0.321-2.235c0.214-0.643,0.511-1.178,0.889-1.606s0.822-0.754,1.333-0.978s1.062-0.335,1.654-0.335 c0.547,0,1.058,0.091,1.531,0.273s0.897,0.456,1.271,0.82l-1.135,1.012c-0.228-0.265-0.48-0.456-0.759-0.574 s-0.567-0.178-0.868-0.178c-0.337,0-0.658,0.063-0.964,0.191s-0.579,0.344-0.82,0.649s-0.431,0.699-0.567,1.183 s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75s0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67 s0.608,0.212,0.937,0.212s0.636-0.06,0.923-0.178s0.549-0.31,0.786-0.574L23.58,51.975z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M31.633,50.238c0,0.364-0.075,0.718-0.226,1.06s-0.362,0.643-0.636,0.902s-0.61,0.467-1.012,0.622 s-0.856,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116s-0.463-0.13-0.677-0.226 s-0.398-0.212-0.554-0.349l0.287-1.176c0.128,0.073,0.289,0.144,0.485,0.212s0.398,0.132,0.608,0.191s0.419,0.107,0.629,0.144 s0.405,0.055,0.588,0.055c0.556,0,0.982-0.13,1.278-0.39s0.444-0.645,0.444-1.155c0-0.31-0.104-0.574-0.314-0.793 s-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533s-0.706-0.388-1.025-0.629s-0.583-0.526-0.793-0.854s-0.314-0.738-0.314-1.23 c0-0.446,0.082-0.843,0.246-1.189s0.385-0.641,0.663-0.882s0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191 c0.419,0,0.843,0.039,1.271,0.116s0.774,0.203,1.039,0.376c-0.055,0.118-0.118,0.248-0.191,0.39s-0.142,0.273-0.205,0.396 c-0.063,0.123-0.118,0.226-0.164,0.308s-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109s-0.166-0.091-0.294-0.137 s-0.296-0.077-0.506-0.096s-0.479-0.014-0.807,0.014c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321 s-0.228,0.271-0.301,0.431s-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882s0.47,0.419,0.779,0.588 s0.647,0.333,1.012,0.492s0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854S31.633,49.7,31.633,50.238z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M39.043,50.238c0,0.364-0.075,0.718-0.226,1.06s-0.362,0.643-0.636,0.902s-0.61,0.467-1.012,0.622 s-0.856,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116s-0.463-0.13-0.677-0.226 s-0.398-0.212-0.554-0.349l0.287-1.176c0.128,0.073,0.289,0.144,0.485,0.212s0.398,0.132,0.608,0.191s0.419,0.107,0.629,0.144 s0.405,0.055,0.588,0.055c0.556,0,0.982-0.13,1.278-0.39s0.444-0.645,0.444-1.155c0-0.31-0.104-0.574-0.314-0.793 s-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533s-0.706-0.388-1.025-0.629s-0.583-0.526-0.793-0.854s-0.314-0.738-0.314-1.23 c0-0.446,0.082-0.843,0.246-1.189s0.385-0.641,0.663-0.882s0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191 c0.419,0,0.843,0.039,1.271,0.116s0.774,0.203,1.039,0.376c-0.055,0.118-0.118,0.248-0.191,0.39s-0.142,0.273-0.205,0.396 s-0.118,0.226-0.164,0.308s-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109s-0.166-0.091-0.294-0.137 s-0.296-0.077-0.506-0.096s-0.479-0.014-0.807,0.014c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321 s-0.228,0.271-0.301,0.431s-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882s0.47,0.419,0.779,0.588 s0.647,0.333,1.012,0.492s0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854S39.043,49.7,39.043,50.238z"
        />
      </g>
      <g>
        <path
          style={{ fill: '#0096e6' }}
          d="M19.5,19v-4c0-0.551,0.448-1,1-1c0.553,0,1-0.448,1-1s-0.447-1-1-1c-1.654,0-3,1.346-3,3v4 c0,1.103-0.897,2-2,2c-0.553,0-1,0.448-1,1s0.447,1,1,1c1.103,0,2,0.897,2,2v4c0,1.654,1.346,3,3,3c0.553,0,1-0.448,1-1 s-0.447-1-1-1c-0.552,0-1-0.449-1-1v-4c0-1.2-0.542-2.266-1.382-3C18.958,21.266,19.5,20.2,19.5,19z"
        />
        <path
          style={{ fill: '#0096e6' }}
          d="M39.5,21c-1.103,0-2-0.897-2-2v-4c0-1.654-1.346-3-3-3c-0.553,0-1,0.448-1,1s0.447,1,1,1 c0.552,0,1,0.449,1,1v4c0,1.2,0.542,2.266,1.382,3c-0.84,0.734-1.382,1.8-1.382,3v4c0,0.551-0.448,1-1,1c-0.553,0-1,0.448-1,1 s0.447,1,1,1c1.654,0,3-1.346,3-3v-4c0-1.103,0.897-2,2-2c0.553,0,1-0.448,1-1S40.053,21,39.5,21z"
        />
      </g>
    </g>
  </IconWrapper>
)

const PptFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#f6712e' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M17.581,53H15.94V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656 s-0.921,0.232-1.449,0.232h-1.217V53z M17.581,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567 c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198H17.581z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M25.853,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656 s-0.921,0.232-1.449,0.232h-1.217V53z M25.853,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567 c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198H25.853z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M39.606,42.924v1.121h-3.008V53h-1.654v-8.955h-3.008v-1.121H39.606z"
        />
      </g>
      <path
        style={{ fill: '#c8bdb8' }}
        d="M39.5,30h-24V14h24V30z M17.5,28h20V16h-20V28z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M20.499,35c-0.175,0-0.353-0.046-0.514-0.143c-0.474-0.284-0.627-0.898-0.343-1.372l3-5 c0.284-0.474,0.898-0.627,1.372-0.343c0.474,0.284,0.627,0.898,0.343,1.372l-3,5C21.17,34.827,20.839,35,20.499,35z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M34.501,35c-0.34,0-0.671-0.173-0.858-0.485l-3-5c-0.284-0.474-0.131-1.088,0.343-1.372 c0.474-0.283,1.088-0.131,1.372,0.343l3,5c0.284,0.474,0.131,1.088-0.343,1.372C34.854,34.954,34.676,35,34.501,35z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M27.5,16c-0.552,0-1-0.447-1-1v-3c0-0.553,0.448-1,1-1s1,0.447,1,1v3C28.5,15.553,28.052,16,27.5,16 z"
      />
      <rect
        x="17.5"
        y="16"
        style={{ fill: '#d3ccc9' }}
        width="20"
        height="12"
      />
    </g>
  </IconWrapper>
)

const XlsFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#91cda0' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M20.379,48.105L22.936,53h-1.9l-1.6-3.801h-0.137L17.576,53h-1.9l2.557-4.895l-2.721-5.182h1.873 l1.777,4.102h0.137l1.928-4.102H23.1L20.379,48.105z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M27.037,42.924v8.832h4.635V53h-6.303V42.924H27.037z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M39.041,50.238c0,0.364-0.075,0.718-0.226,1.06S38.453,51.94,38.18,52.2s-0.611,0.467-1.012,0.622 c-0.401,0.155-0.857,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116 c-0.237-0.055-0.463-0.13-0.677-0.226c-0.214-0.096-0.399-0.212-0.554-0.349l0.287-1.176c0.127,0.073,0.289,0.144,0.485,0.212 c0.196,0.068,0.398,0.132,0.608,0.191c0.209,0.06,0.419,0.107,0.629,0.144c0.209,0.036,0.405,0.055,0.588,0.055 c0.556,0,0.982-0.13,1.278-0.39c0.296-0.26,0.444-0.645,0.444-1.155c0-0.31-0.105-0.574-0.314-0.793 c-0.21-0.219-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533c-0.365-0.178-0.707-0.388-1.025-0.629 c-0.319-0.241-0.583-0.526-0.793-0.854c-0.21-0.328-0.314-0.738-0.314-1.23c0-0.446,0.082-0.843,0.246-1.189 s0.385-0.641,0.663-0.882c0.278-0.241,0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191c0.419,0,0.843,0.039,1.271,0.116 c0.428,0.077,0.774,0.203,1.039,0.376c-0.055,0.118-0.119,0.248-0.191,0.39c-0.073,0.142-0.142,0.273-0.205,0.396 c-0.064,0.123-0.119,0.226-0.164,0.308c-0.046,0.082-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109 s-0.167-0.091-0.294-0.137c-0.128-0.046-0.296-0.077-0.506-0.096c-0.21-0.019-0.479-0.014-0.807,0.014 c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321c-0.128,0.128-0.228,0.271-0.301,0.431 c-0.073,0.159-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882c0.209,0.224,0.469,0.419,0.779,0.588 c0.31,0.169,0.647,0.333,1.012,0.492c0.364,0.159,0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854 C38.936,49.261,39.041,49.7,39.041,50.238z"
        />
      </g>
      <path
        style={{ fill: '#c8bdb8' }}
        d="M23.5,16v-4h-12v4v2v2v2v2v2v2v2v4h10h2h21v-4v-2v-2v-2v-2v-2v-4H23.5z M13.5,14h8v2h-8V14z M13.5,18h8v2h-8V18z M13.5,22h8v2h-8V22z M13.5,26h8v2h-8V26z M21.5,32h-8v-2h8V32z M42.5,32h-19v-2h19V32z M42.5,28h-19v-2h19V28 z M42.5,24h-19v-2h19V24z M23.5,20v-2h19v2H23.5z"
      />
    </g>
  </IconWrapper>
)

const TxtFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#95a5a5' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M21.867,42.924v1.121h-3.008V53h-1.654v-8.955h-3.008v-1.121H21.867z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M28.443,48.105L31,53h-1.9l-1.6-3.801h-0.137L25.641,53h-1.9l2.557-4.895l-2.721-5.182h1.873 l1.777,4.102h0.137l1.928-4.102h1.873L28.443,48.105z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M40.529,42.924v1.121h-3.008V53h-1.654v-8.955h-3.008v-1.121H40.529z"
        />
      </g>
      <path
        style={{ fill: '#c8bdb8' }}
        d="M18.5,13h-6c-0.553,0-1-0.448-1-1s0.447-1,1-1h6c0.553,0,1,0.448,1,1S19.053,13,18.5,13z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M21.5,18h-9c-0.553,0-1-0.448-1-1s0.447-1,1-1h9c0.553,0,1,0.448,1,1S22.053,18,21.5,18z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M25.5,18c-0.26,0-0.521-0.11-0.71-0.29c-0.181-0.19-0.29-0.44-0.29-0.71s0.109-0.52,0.3-0.71 c0.36-0.37,1.04-0.37,1.41,0c0.18,0.19,0.29,0.45,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C26.02,17.89,25.76,18,25.5,18z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M37.5,18h-8c-0.553,0-1-0.448-1-1s0.447-1,1-1h8c0.553,0,1,0.448,1,1S38.053,18,37.5,18z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M12.5,33c-0.26,0-0.521-0.11-0.71-0.29c-0.181-0.19-0.29-0.45-0.29-0.71 c0-0.26,0.109-0.52,0.29-0.71c0.37-0.37,1.05-0.37,1.42,0.01c0.18,0.18,0.29,0.44,0.29,0.7c0,0.26-0.11,0.52-0.29,0.71 C13.02,32.89,12.76,33,12.5,33z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M24.5,33h-8c-0.553,0-1-0.448-1-1s0.447-1,1-1h8c0.553,0,1,0.448,1,1S25.053,33,24.5,33z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M43.5,18h-2c-0.553,0-1-0.448-1-1s0.447-1,1-1h2c0.553,0,1,0.448,1,1S44.053,18,43.5,18z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M34.5,23h-22c-0.553,0-1-0.448-1-1s0.447-1,1-1h22c0.553,0,1,0.448,1,1S35.053,23,34.5,23z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M43.5,23h-6c-0.553,0-1-0.448-1-1s0.447-1,1-1h6c0.553,0,1,0.448,1,1S44.053,23,43.5,23z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M16.5,28h-4c-0.553,0-1-0.448-1-1s0.447-1,1-1h4c0.553,0,1,0.448,1,1S17.053,28,16.5,28z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M30.5,28h-10c-0.553,0-1-0.448-1-1s0.447-1,1-1h10c0.553,0,1,0.448,1,1S31.053,28,30.5,28z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M43.5,28h-9c-0.553,0-1-0.448-1-1s0.447-1,1-1h9c0.553,0,1,0.448,1,1S44.053,28,43.5,28z"
      />
    </g>
  </IconWrapper>
)

const RtfFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#90bae1' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M20.83,53l-1.9-3.65c-0.027,0-0.064,0.002-0.109,0.007c-0.046,0.005-0.116,0.007-0.212,0.007 s-0.241,0-0.438,0s-0.463,0-0.8,0V53H15.73V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205c0.419,0.137,0.795,0.342,1.128,0.615 s0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306c0,0.729-0.169,1.349-0.506,1.859c-0.338,0.511-0.793,0.889-1.367,1.135 L22.566,53H20.83z M17.371,48.16h1.49c0.2,0,0.4-0.034,0.602-0.103c0.2-0.068,0.383-0.18,0.547-0.335s0.296-0.371,0.396-0.649 c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615s-0.34-0.36-0.595-0.492 c-0.256-0.132-0.593-0.198-1.012-0.198h-1.23V48.16z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M31.891,42.924v1.121h-3.008V53h-1.654v-8.955h-3.008v-1.121H31.891z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M35.555,44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924h6.303v1.244H35.555z"
        />
      </g>
      <g>
        <path
          style={{ fill: '#c8bdb8' }}
          d="M12.5,13h6c0.553,0,1-0.448,1-1s-0.447-1-1-1h-6c-0.553,0-1,0.448-1,1S11.947,13,12.5,13z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M12.5,18h9c0.553,0,1-0.448,1-1s-0.447-1-1-1h-9c-0.553,0-1,0.448-1,1S11.947,18,12.5,18z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M25.5,18c0.26,0,0.52-0.11,0.71-0.29c0.18-0.19,0.29-0.45,0.29-0.71c0-0.26-0.11-0.52-0.29-0.71 c-0.38-0.37-1.04-0.37-1.42,0c-0.181,0.19-0.29,0.44-0.29,0.71s0.109,0.52,0.29,0.71C24.979,17.89,25.24,18,25.5,18z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M29.5,18h8c0.553,0,1-0.448,1-1s-0.447-1-1-1h-8c-0.553,0-1,0.448-1,1S28.947,18,29.5,18z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M11.79,31.29c-0.181,0.19-0.29,0.44-0.29,0.71s0.109,0.52,0.29,0.71 C11.979,32.89,12.229,33,12.5,33c0.27,0,0.52-0.11,0.71-0.29c0.18-0.19,0.29-0.45,0.29-0.71c0-0.26-0.11-0.52-0.29-0.71 C12.84,30.92,12.16,30.92,11.79,31.29z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M24.5,31h-8c-0.553,0-1,0.448-1,1s0.447,1,1,1h8c0.553,0,1-0.448,1-1S25.053,31,24.5,31z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M41.5,18h2c0.553,0,1-0.448,1-1s-0.447-1-1-1h-2c-0.553,0-1,0.448-1,1S40.947,18,41.5,18z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M12.5,23h22c0.553,0,1-0.448,1-1s-0.447-1-1-1h-22c-0.553,0-1,0.448-1,1S11.947,23,12.5,23z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M43.5,21h-6c-0.553,0-1,0.448-1,1s0.447,1,1,1h6c0.553,0,1-0.448,1-1S44.053,21,43.5,21z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M12.5,28h4c0.553,0,1-0.448,1-1s-0.447-1-1-1h-4c-0.553,0-1,0.448-1,1S11.947,28,12.5,28z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M30.5,26h-10c-0.553,0-1,0.448-1,1s0.447,1,1,1h10c0.553,0,1-0.448,1-1S31.053,26,30.5,26z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M43.5,26h-9c-0.553,0-1,0.448-1,1s0.447,1,1,1h9c0.553,0,1-0.448,1-1S44.053,26,43.5,26z"
        />
      </g>
    </g>
  </IconWrapper>
)

const DocFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M18.5,13h-6c-0.552,0-1-0.448-1-1s0.448-1,1-1h6c0.552,0,1,0.448,1,1S19.052,13,18.5,13z"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M21.5,18h-9c-0.552,0-1-0.448-1-1s0.448-1,1-1h9c0.552,0,1,0.448,1,1S22.052,18,21.5,18z"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M25.5,18c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71c0-0.26,0.11-0.52,0.29-0.71 c0.37-0.37,1.05-0.37,1.42,0c0.18,0.19,0.29,0.45,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C26.02,17.89,25.76,18,25.5,18z"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M37.5,18h-8c-0.552,0-1-0.448-1-1s0.448-1,1-1h8c0.552,0,1,0.448,1,1S38.052,18,37.5,18z"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M12.5,33c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71c0-0.26,0.11-0.52,0.29-0.71 c0.37-0.37,1.05-0.37,1.42,0c0.18,0.19,0.29,0.44,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C13.02,32.89,12.76,33,12.5,33z"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M24.5,33h-8c-0.552,0-1-0.448-1-1s0.448-1,1-1h8c0.552,0,1,0.448,1,1S25.052,33,24.5,33z"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M43.5,18h-2c-0.552,0-1-0.448-1-1s0.448-1,1-1h2c0.552,0,1,0.448,1,1S44.052,18,43.5,18z"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M34.5,23h-22c-0.552,0-1-0.448-1-1s0.448-1,1-1h22c0.552,0,1,0.448,1,1S35.052,23,34.5,23z"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M43.5,23h-6c-0.552,0-1-0.448-1-1s0.448-1,1-1h6c0.552,0,1,0.448,1,1S44.052,23,43.5,23z"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M16.5,28h-4c-0.552,0-1-0.448-1-1s0.448-1,1-1h4c0.552,0,1,0.448,1,1S17.052,28,16.5,28z"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M30.5,28h-10c-0.552,0-1-0.448-1-1s0.448-1,1-1h10c0.552,0,1,0.448,1,1S31.052,28,30.5,28z"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M43.5,28h-9c-0.552,0-1-0.448-1-1s0.448-1,1-1h9c0.552,0,1,0.448,1,1S44.052,28,43.5,28z"
      />
      <path
        style={{ fill: '#0096e6' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M23.5,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937 s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C19.503,52.984,19.307,53,19.18,53h-3.814V42.924H18.4 c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C23.395,46.494,23.5,47.08,23.5,47.682z M18.633,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244 c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H18.633z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M33.475,47.914c0,0.848-0.107,1.595-0.321,2.242c-0.214,0.647-0.511,1.185-0.889,1.613 c-0.378,0.429-0.82,0.752-1.326,0.971s-1.06,0.328-1.661,0.328s-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971 c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235 c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.82-0.754,1.326-0.978s1.06-0.335,1.661-0.335s1.155,0.111,1.661,0.335 s0.948,0.549,1.326,0.978c0.378,0.429,0.674,0.964,0.889,1.606C33.367,46.321,33.475,47.066,33.475,47.914z M29.236,51.729 c0.337,0,0.658-0.066,0.964-0.198c0.305-0.132,0.579-0.349,0.82-0.649c0.241-0.301,0.431-0.695,0.567-1.183 s0.209-1.082,0.219-1.784c-0.009-0.684-0.08-1.265-0.212-1.743c-0.132-0.479-0.314-0.873-0.547-1.183s-0.497-0.533-0.793-0.67 c-0.296-0.137-0.608-0.205-0.937-0.205c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649 c-0.242,0.306-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75 c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67C28.596,51.658,28.908,51.729,29.236,51.729z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M42.607,51.975c-0.374,0.364-0.798,0.638-1.271,0.82c-0.474,0.183-0.984,0.273-1.531,0.273 c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971c-0.378-0.429-0.675-0.966-0.889-1.613 c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235c0.214-0.643,0.51-1.178,0.889-1.606 c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335c0.547,0,1.057,0.091,1.531,0.273 c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.228-0.265-0.481-0.456-0.759-0.574c-0.278-0.118-0.567-0.178-0.868-0.178 c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649c-0.242,0.306-0.431,0.699-0.567,1.183 s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67 c0.296,0.142,0.608,0.212,0.937,0.212s0.636-0.06,0.923-0.178s0.549-0.31,0.786-0.574L42.607,51.975z"
        />
      </g>
    </g>
  </IconWrapper>
)

const PdfFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#cc4b4c' }}
        d="M19.514,33.324L19.514,33.324c-0.348,0-0.682-0.113-0.967-0.326 c-1.041-0.781-1.181-1.65-1.115-2.242c0.182-1.628,2.195-3.332,5.985-5.068c1.504-3.296,2.935-7.357,3.788-10.75 c-0.998-2.172-1.968-4.99-1.261-6.643c0.248-0.579,0.557-1.023,1.134-1.215c0.228-0.076,0.804-0.172,1.016-0.172 c0.504,0,0.947,0.649,1.261,1.049c0.295,0.376,0.964,1.173-0.373,6.802c1.348,2.784,3.258,5.62,5.088,7.562 c1.311-0.237,2.439-0.358,3.358-0.358c1.566,0,2.515,0.365,2.902,1.117c0.32,0.622,0.189,1.349-0.39,2.16 c-0.557,0.779-1.325,1.191-2.22,1.191c-1.216,0-2.632-0.768-4.211-2.285c-2.837,0.593-6.15,1.651-8.828,2.822 c-0.836,1.774-1.637,3.203-2.383,4.251C21.273,32.654,20.389,33.324,19.514,33.324z M22.176,28.198 c-2.137,1.201-3.008,2.188-3.071,2.744c-0.01,0.092-0.037,0.334,0.431,0.692C19.685,31.587,20.555,31.19,22.176,28.198z M35.813,23.756c0.815,0.627,1.014,0.944,1.547,0.944c0.234,0,0.901-0.01,1.21-0.441c0.149-0.209,0.207-0.343,0.23-0.415 c-0.123-0.065-0.286-0.197-1.175-0.197C37.12,23.648,36.485,23.67,35.813,23.756z M28.343,17.174 c-0.715,2.474-1.659,5.145-2.674,7.564c2.09-0.811,4.362-1.519,6.496-2.02C30.815,21.15,29.466,19.192,28.343,17.174z M27.736,8.712c-0.098,0.033-1.33,1.757,0.096,3.216C28.781,9.813,27.779,8.698,27.736,8.712z"
      />
      <path
        style={{ fill: '#cc4b4c' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M17.385,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656 s-0.921,0.232-1.449,0.232h-1.217V53z M17.385,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032 c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492 c-0.255-0.132-0.593-0.198-1.012-0.198H17.385z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M32.219,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937 s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C28.222,52.984,28.026,53,27.898,53h-3.814V42.924h3.035 c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C32.114,46.494,32.219,47.08,32.219,47.682z M27.352,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244 c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H27.352z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M36.266,44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924H40.9v1.244H36.266z"
        />
      </g>
    </g>
  </IconWrapper>
)

const RarFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g>
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#ce3c3b', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#c8bdb8' }}
          d="M28.5,24v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2V8h-2V6h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2 h-4v5c0,2.757,2.243,5,5,5s5-2.243,5-5v-5H28.5z M30.5,29c0,1.654-1.346,3-3,3s-3-1.346-3-3v-3h6V29z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M26.5,30h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S25.948,30,26.5,30z"
        />
      </g>
    </g>
    <g
      transform="scale(0.99499753,1.0050276)"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.81912994px',
        fontFamily: 'Allerta',
        fill: '#fff',
        fillOpacity: 1,
      }}
    >
      <path
        d="m 20.219066,52.709572 -1.875839,-3.60323 q -0.04049,0 -0.107962,0.01349 -0.06748,0 -0.215924,0 -0.134952,0 -0.431848,0 -0.2834,0 -0.782724,0 l 0,3.589735 -1.619429,0 0,-9.945995 2.860992,0 q 0.634276,0 1.255057,0.202429 0.620782,0.202428 1.10661,0.607286 0.499324,0.404857 0.79622,0.985152 0.31039,0.566801 0.31039,1.282049 0,1.079619 -0.499324,1.835353 -0.499324,0.755733 -1.349524,1.120105 l 2.267201,3.913621 -1.713896,0 z m -3.414297,-4.777317 1.470982,0 q 0.296895,0 0.593791,-0.09447 0.296895,-0.107962 0.539809,-0.337381 0.242915,-0.22942 0.391362,-0.634277 0.148448,-0.418352 0.148448,-1.025638 0,-0.242915 -0.06748,-0.553305 -0.06748,-0.323886 -0.2834,-0.607286 -0.202429,-0.296896 -0.580296,-0.485829 -0.377867,-0.202429 -0.998648,-0.202429 l -1.214572,0 0,3.940611 z"
        style={{ fill: '#fff' }}
      />
      <path
        d="m 23.72783,52.709572 3.481773,-9.9325 1.605934,0 3.454782,9.9325 -1.67341,0 -0.715248,-2.064773 -3.738183,0 -0.728743,2.064773 -1.686905,0 z m 2.793515,-3.157887 2.968954,0 -1.470982,-4.291488 -1.497972,4.291488 z"
        style={{ fill: '#fff' }}
      />
      <path
        d="m 39.382312,52.709572 -1.875839,-3.60323 q -0.04049,0 -0.107962,0.01349 -0.06748,0 -0.215924,0 -0.134952,0 -0.431847,0 -0.283401,0 -0.782725,0 l 0,3.589735 -1.619429,0 0,-9.945995 2.860992,0 q 0.634276,0 1.255058,0.202429 0.620781,0.202428 1.10661,0.607286 0.499324,0.404857 0.796219,0.985152 0.310391,0.566801 0.310391,1.282049 0,1.079619 -0.499324,1.835353 -0.499324,0.755733 -1.349525,1.120105 l 2.267201,3.913621 -1.713896,0 z m -3.414297,-4.777317 1.470982,0 q 0.296895,0 0.593791,-0.09447 0.296895,-0.107962 0.539809,-0.337381 0.242915,-0.22942 0.391363,-0.634277 0.148447,-0.418352 0.148447,-1.025638 0,-0.242915 -0.06748,-0.553305 -0.06748,-0.323886 -0.2834,-0.607286 -0.202429,-0.296896 -0.580296,-0.485829 -0.377866,-0.202429 -0.998648,-0.202429 l -1.214572,0 0,3.940611 z"
        style={{ fill: '#fff' }}
      />
    </g>
  </IconWrapper>
)

const ArjFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#95a5a5', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#c8bdb8' }}
          d="M28.5,24v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2V8h-2V6h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2 h-4v5c0,2.757,2.243,5,5,5s5-2.243,5-5v-5H28.5z M30.5,29c0,1.654-1.346,3-3,3s-3-1.346-3-3v-3h6V29z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M26.5,30h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S25.948,30,26.5,30z"
        />
      </g>
    </g>
    <g
      xmlns="http://www.w3.org/2000/svg"
      transform="scale(0.99029518,1.0097999)"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.88474941px',
        fontFamily: 'Allerta',
        fill: '#fff',
        fillOpacity: 0.94117647,
      }}
    >
      <path
        d="m 15.840497,52.525024 3.498306,-9.979663 1.61356,0 3.471187,9.979663 -1.681356,0 -0.718645,-2.074576 -3.755933,0 -0.732203,2.074576 -1.694916,0 z m 2.80678,-3.172882 2.983052,0 -1.477966,-4.311865 -1.505086,4.311865 z"
        style={{ fill: '#fff', fillOpacity: 1 }}
      />
      <path
        d="m 31.569314,52.525024 -1.884746,-3.62034 q -0.04068,0 -0.108475,0.01356 -0.0678,0 -0.216949,0 -0.135593,0 -0.433898,0 -0.284746,0 -0.786441,0 l 0,3.60678 -1.627119,0 0,-9.993223 2.874577,0 q 0.637288,0 1.261017,0.20339 0.623729,0.20339 1.111865,0.61017 0.501695,0.40678 0.8,0.989831 0.311865,0.569491 0.311865,1.288136 0,1.084746 -0.501695,1.844068 -0.501696,0.759322 -1.355933,1.125424 l 2.277967,3.932204 -1.722035,0 z m -3.430509,-4.800001 1.477966,0 q 0.298306,0 0.596611,-0.09492 0.298305,-0.108475 0.542373,-0.338983 0.244068,-0.230509 0.39322,-0.637289 0.149153,-0.420339 0.149153,-1.030508 0,-0.244068 -0.0678,-0.555933 -0.0678,-0.325423 -0.284746,-0.610169 -0.20339,-0.298305 -0.583051,-0.488136 -0.379661,-0.20339 -1.00339,-0.20339 l -1.220339,0 0,3.959323 z"
        style={{ fill: '#fff', fillOpacity: 1 }}
      />
      <path
        d="m 40.7083,42.328412 0,7.783052 q 0,0.705085 -0.257627,1.193221 -0.257628,0.474577 -0.691526,0.772882 -0.433898,0.284746 -1.00339,0.406779 -0.555933,0.108475 -1.152543,0.108475 -0.298305,0 -0.705085,-0.0678 -0.39322,-0.05424 -0.827119,-0.176271 -0.420339,-0.135593 -0.813559,-0.298305 -0.393221,-0.162712 -0.664407,-0.366102 l 0.691525,-1.098305 q 0.135594,0.09492 0.379662,0.20339 0.257627,0.09492 0.555932,0.18983 0.298305,0.08136 0.623729,0.149153 0.325424,0.0678 0.61017,0.0678 0.718644,0 1.138983,-0.271187 0.433898,-0.284746 0.461017,-0.949153 l 0,-7.647459 1.654238,0 z"
        style={{ fill: '#fff', fillOpacity: 1 }}
      />
    </g>
  </IconWrapper>
)

const Archive7zFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#90bae1', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#c8bdb8' }}
          d="M28.5,24v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2V8h-2V6h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2 h-4v5c0,2.757,2.243,5,5,5s5-2.243,5-5v-5H28.5z M30.5,29c0,1.654-1.346,3-3,3s-3-1.346-3-3v-3h6V29z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M26.5,30h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S25.948,30,26.5,30z"
        />
      </g>
    </g>
    <g
      xmlns="http://www.w3.org/2000/svg"
      transform="scale(0.99005755,1.0100423)"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.88808155px',
        fontFamily: 'Allerta',
        fill: '#fff',
        fillOpacity: 1,
      }}
    >
      <path
        d="m 22.232274,52.472202 3.47202,-8.666488 -4.353588,0 0,-1.329133 6.279474,0 -3.878897,9.995621 -1.519009,0 z"
        style={{ fill: '#fff' }}
      />
      <path
        d="m 29.393316,44.822907 5.818346,0 0,1.315571 -3.933148,4.801153 -0.271251,0.217001 4.204399,0 0,1.31557 -5.818346,0 0,-1.31557 3.933148,-4.801153 0.271251,-0.217001 -4.204399,0 0,-1.315571 z"
        style={{ fill: '#fff' }}
      />
    </g>
  </IconWrapper>
)

const ZipFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#556080' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M25.266,42.924v1.326l-4.799,7.205l-0.273,0.219h5.072V53h-6.699v-1.326l4.799-7.205l0.287-0.219 h-5.086v-1.326H25.266z"
        />
        <path style={{ fill: '#fff' }} d="M29.271,53h-1.668V42.924h1.668V53z" />
        <path
          style={{ fill: '#fff' }}
          d="M33.414,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656 s-0.921,0.232-1.449,0.232h-1.217V53z M33.414,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567 c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198H33.414z"
        />
      </g>
      <g>
        <path
          style={{ fill: '#c8bdb8' }}
          d="M28.5,24v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2V8h-2V6h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2 h-4v5c0,2.757,2.243,5,5,5s5-2.243,5-5v-5H28.5z M30.5,29c0,1.654-1.346,3-3,3s-3-1.346-3-3v-3h6V29z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M26.5,30h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S25.948,30,26.5,30z"
        />
      </g>
    </g>
  </IconWrapper>
)

const NrgFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#ce3c3b', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <circle style={{ fill: '#c8bdb8' }} cx="27.5" cy="21" r="12" />
      <circle style={{ fill: '#e9e9e0' }} cx="27.5" cy="21" r="3" />
      <path
        style={{ fill: '#d3ccc9' }}
        d="M25.379,18.879c0.132-0.132,0.276-0.245,0.425-0.347l-2.361-8.813 c-1.615,0.579-3.134,1.503-4.427,2.796c-1.294,1.293-2.217,2.812-2.796,4.427l8.813,2.361 C25.134,19.155,25.247,19.011,25.379,18.879z"
      />
      <path
        style={{ fill: '#d3ccc9' }}
        d="M30.071,23.486l2.273,8.483c1.32-0.582,2.56-1.402,3.641-2.484c1.253-1.253,2.16-2.717,2.743-4.275 l-8.188-2.194C30.255,22.939,29.994,23.2,30.071,23.486z"
      />
    </g>
    <g
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.75px',
        fontFamily: 'Allerta',
        letterSpacing: '.15000001px',
        fill: '#fff',
        fillOpacity: 1,
      }}
    >
      <path
        d="m 22.163355,43.019012 0,9.896241 -1.638184,0 -3.880615,-6.821289 0,6.821289 -1.638184,0 0,-9.896241 1.638184,0 3.880615,6.82129 0,-6.82129 1.638184,0 z"
        style={{ fill: '#fff' }}
      />
      <path
        d="m 29.752319,52.915253 -1.866455,-3.585205 q -0.04028,0 -0.107422,0.01343 -0.06714,0 -0.214843,0 -0.134278,0 -0.429688,0 -0.281982,0 -0.778808,0 l 0,3.571778 -1.611329,0 0,-9.896241 2.84668,0 q 0.631104,0 1.248779,0.201416 0.617676,0.201416 1.101075,0.604249 0.496826,0.402832 0.792236,0.980224 0.308838,0.563965 0.308838,1.275635 0,1.074219 -0.496826,1.826172 -0.496827,0.751953 -1.342774,1.114502 l 2.25586,3.894043 -1.705323,0 z m -3.397216,-4.753418 1.463623,0 q 0.29541,0 0.59082,-0.09399 0.29541,-0.107422 0.537109,-0.335694 0.241699,-0.228271 0.389405,-0.631103 0.147705,-0.41626 0.147705,-1.020508 0,-0.241699 -0.06714,-0.550537 -0.06714,-0.322266 -0.281982,-0.604248 -0.201416,-0.29541 -0.577393,-0.483399 -0.375977,-0.201416 -0.993652,-0.201416 l -1.208496,0 0,3.920899 z"
        style={{ fill: '#fff', fillOpacity: 1 }}
      />
      <path
        d="m 40.993628,47.812714 0,3.826904 q -0.308838,0.389404 -0.698243,0.644531 -0.375976,0.241699 -0.805664,0.402832 -0.416259,0.161133 -0.872802,0.228272 -0.443116,0.06714 -0.886231,0.06714 -0.88623,0 -1.638183,-0.322265 -0.738526,-0.322266 -1.302491,-0.953369 -0.550537,-0.631104 -0.872802,-1.584473 -0.308838,-0.953369 -0.308838,-2.202149 0,-1.248779 0.308838,-2.18872 0.322265,-0.953369 0.872802,-1.584473 0.563965,-0.631103 1.315918,-0.953369 0.751953,-0.335693 1.624756,-0.335693 0.805664,0 1.503906,0.268554 0.698243,0.268555 1.24878,0.805664 l -1.114502,0.993653 q -0.322266,-0.389405 -0.738526,-0.563965 -0.416259,-0.174561 -0.859375,-0.174561 -0.496826,0 -0.953369,0.187989 -0.443115,0.187988 -0.805664,0.644531 -0.349121,0.443115 -0.550537,1.154785 -0.201416,0.71167 -0.214844,1.745605 0.01343,1.007081 0.201416,1.745606 0.201416,0.738525 0.53711,1.208496 0.349121,0.469971 0.778808,0.698242 0.443115,0.228272 0.926514,0.228272 0.147705,0 0.389404,-0.01343 0.255127,-0.02685 0.496826,-0.06714 0.255127,-0.05371 0.483399,-0.134277 0.228271,-0.08057 0.335693,-0.228272 l 0,-2.443847 -1.678467,0 0,-1.101074 3.276368,0 z"
        style={{ fill: '#fff' }}
      />
    </g>
  </IconWrapper>
)

const MdfFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#556080', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <circle style={{ fill: '#c8bdb8' }} cx="27.5" cy="21" r="12" />
      <circle style={{ fill: '#e9e9e0' }} cx="27.5" cy="21" r="3" />
      <path
        style={{ fill: '#d3ccc9' }}
        d="M25.379,18.879c0.132-0.132,0.276-0.245,0.425-0.347l-2.361-8.813 c-1.615,0.579-3.134,1.503-4.427,2.796c-1.294,1.293-2.217,2.812-2.796,4.427l8.813,2.361 C25.134,19.155,25.247,19.011,25.379,18.879z"
      />
      <path
        style={{ fill: '#d3ccc9' }}
        d="M30.071,23.486l2.273,8.483c1.32-0.582,2.56-1.402,3.641-2.484c1.253-1.253,2.16-2.717,2.743-4.275 l-8.188-2.194C30.255,22.939,29.994,23.2,30.071,23.486z"
      />
    </g>
    <g
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.75px',
        fontFamily: 'Allerta',
        letterSpacing: '.15000001px',
        fill: '#fff',
        fillOpacity: 1,
      }}
    >
      <path
        d="m 21.256983,42.95969 1.638183,0 0,9.89624 -1.638183,0 0,-6.807861 -2.215576,5.505371 -1.42334,0 -2.229004,-5.505371 0,6.807861 -1.638184,0 0,-9.89624 1.638184,0 2.940674,6.767578 2.927246,-6.767578 z"
        style={{ fill: '#fff' }}
      />
      <path
        d="m 33.57251,47.632542 q 0,1.221923 -0.268555,2.094726 -0.255127,0.859375 -0.657959,1.450196 -0.402832,0.577392 -0.913086,0.913085 -0.496826,0.335694 -0.966797,0.510254 -0.46997,0.161133 -0.859375,0.214844 -0.389404,0.04028 -0.577392,0.04028 l -3.746338,0 0,-9.89624 2.980957,0 q 1.248779,0 2.188721,0.402832 0.953369,0.389404 1.571044,1.047363 0.631104,0.657959 0.939942,1.503907 0.308838,0.832519 0.308838,1.71875 z m -4.780274,4.041748 q 1.638184,0 2.363282,-1.047364 0.725097,-1.047363 0.725097,-3.034668 0,-0.617675 -0.147705,-1.221923 -0.147705,-0.604248 -0.577392,-1.087647 -0.41626,-0.496826 -1.141358,-0.792236 -0.725098,-0.308838 -1.879883,-0.308838 l -0.939941,0 0,7.492676 1.5979,0 z"
        style={{ fill: '#fff' }}
      />
      <path
        d="m 37.697119,44.181614 0,3.115234 4.135742,0 0,1.101075 -4.135742,0 0,4.458007 -1.638184,0 0,-9.89624 6.190186,0 0,1.221924 -4.552002,0 z"
        style={{ fill: '#fff' }}
      />
    </g>
  </IconWrapper>
)

const IsoFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#71c285' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path style={{ fill: '#fff' }} d="M20.453,53h-1.668V42.924h1.668V53z" />
        <path
          style={{ fill: '#fff' }}
          d="M28.67,50.238c0,0.364-0.075,0.718-0.226,1.06s-0.362,0.643-0.636,0.902s-0.611,0.467-1.012,0.622 c-0.401,0.155-0.857,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.468-0.062-0.704-0.116 c-0.237-0.055-0.463-0.13-0.677-0.226s-0.399-0.212-0.554-0.349l0.287-1.176c0.127,0.073,0.289,0.144,0.485,0.212 s0.398,0.132,0.608,0.191c0.209,0.06,0.419,0.107,0.629,0.144c0.209,0.036,0.405,0.055,0.588,0.055c0.556,0,0.982-0.13,1.278-0.39 s0.444-0.645,0.444-1.155c0-0.31-0.105-0.574-0.314-0.793c-0.21-0.219-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533 c-0.365-0.178-0.707-0.388-1.025-0.629c-0.319-0.241-0.584-0.526-0.793-0.854c-0.21-0.328-0.314-0.738-0.314-1.23 c0-0.446,0.082-0.843,0.246-1.189s0.385-0.641,0.663-0.882s0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191 c0.419,0,0.843,0.039,1.271,0.116c0.428,0.077,0.774,0.203,1.039,0.376c-0.055,0.118-0.119,0.248-0.191,0.39 c-0.073,0.142-0.142,0.273-0.205,0.396c-0.064,0.123-0.119,0.226-0.164,0.308c-0.046,0.082-0.073,0.128-0.082,0.137 c-0.055-0.027-0.116-0.063-0.185-0.109s-0.167-0.091-0.294-0.137c-0.128-0.046-0.297-0.077-0.506-0.096 c-0.21-0.019-0.479-0.014-0.807,0.014c-0.183,0.019-0.355,0.07-0.52,0.157s-0.311,0.193-0.438,0.321 c-0.128,0.128-0.229,0.271-0.301,0.431c-0.073,0.159-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882 c0.209,0.224,0.469,0.419,0.779,0.588c0.31,0.169,0.646,0.333,1.012,0.492c0.364,0.159,0.704,0.354,1.019,0.581 s0.576,0.513,0.786,0.854C28.564,49.261,28.67,49.7,28.67,50.238z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M38.568,47.914c0,0.848-0.107,1.595-0.321,2.242s-0.511,1.185-0.889,1.613s-0.82,0.752-1.326,0.971 s-1.06,0.328-1.661,0.328s-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971s-0.675-0.966-0.889-1.613s-0.321-1.395-0.321-2.242 s0.107-1.593,0.321-2.235s0.511-1.178,0.889-1.606s0.82-0.754,1.326-0.978s1.06-0.335,1.661-0.335s1.155,0.111,1.661,0.335 s0.948,0.549,1.326,0.978s0.675,0.964,0.889,1.606S38.568,47.066,38.568,47.914z M34.33,51.729c0.337,0,0.658-0.066,0.964-0.198 s0.579-0.349,0.82-0.649s0.431-0.695,0.567-1.183s0.209-1.082,0.219-1.784c-0.01-0.684-0.08-1.265-0.212-1.743 s-0.314-0.873-0.547-1.183s-0.497-0.533-0.793-0.67s-0.608-0.205-0.937-0.205c-0.338,0-0.658,0.063-0.964,0.191 s-0.579,0.344-0.82,0.649s-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75 s0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67S34.002,51.729,34.33,51.729z"
        />
      </g>
      <circle style={{ fill: '#c8bdb8' }} cx="27.5" cy="21" r="12" />
      <circle style={{ fill: '#e9e9e0' }} cx="27.5" cy="21" r="3" />
      <path
        style={{ fill: '#d3ccc9' }}
        d="M25.379,18.879c0.132-0.132,0.276-0.245,0.425-0.347l-2.361-8.813 c-1.615,0.579-3.134,1.503-4.427,2.796c-1.294,1.293-2.217,2.812-2.796,4.427l8.813,2.361 C25.134,19.155,25.247,19.011,25.379,18.879z"
      />
      <path
        style={{ fill: '#d3ccc9' }}
        d="M30.071,23.486l2.273,8.483c1.32-0.582,2.56-1.402,3.641-2.484c1.253-1.253,2.16-2.717,2.743-4.275 l-8.188-2.194C30.255,22.939,29.994,23.2,30.071,23.486z"
      />
    </g>
  </IconWrapper>
)

const MxfFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <path
        style={{ fill: '#95a5a5', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M24.5,28c-0.166,0-0.331-0.041-0.481-0.123C23.699,27.701,23.5,27.365,23.5,27V13 c0-0.365,0.199-0.701,0.519-0.877c0.321-0.175,0.71-0.162,1.019,0.033l11,7C36.325,19.34,36.5,19.658,36.5,20 s-0.175,0.66-0.463,0.844l-11,7C24.874,27.947,24.687,28,24.5,28z M25.5,14.821v10.357L33.637,20L25.5,14.821z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M28.5,35c-8.271,0-15-6.729-15-15s6.729-15,15-15s15,6.729,15,15S36.771,35,28.5,35z M28.5,7 c-7.168,0-13,5.832-13,13s5.832,13,13,13s13-5.832,13-13S35.668,7,28.5,7z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
    </g>
    <g
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.75px',
        fontFamily: 'Allerta',
        fill: '#fff',
        fillOpacity: 1,
      }}
    >
      <path d="m 21.863525,42.55188 1.638184,0 0,9.89624 -1.638184,0 0,-6.807861 -2.215576,5.505371 -1.42334,0 -2.229004,-5.505371 0,6.807861 -1.638183,0 0,-9.89624 1.638183,0 2.940674,6.767578 2.927246,-6.767578 z" />
      <path d="m 30.524414,47.640991 2.510986,4.807129 -1.866455,0 -1.571045,-3.73291 -0.134277,0 -1.691894,3.73291 -1.866456,0 2.510987,-4.807129 -2.672119,-5.089111 1.839599,0 1.745606,4.02832 0.134277,0 1.893311,-4.02832 1.839599,0 -2.672119,5.089111 z" />
      <path d="m 37.090576,43.773804 0,3.115234 4.135742,0 0,1.101074 -4.135742,0 0,4.458008 -1.638183,0 0,-9.89624 6.190185,0 0,1.221924 -4.552002,0 z" />
    </g>
  </IconWrapper>
)

const WavFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#556080', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M35.67,14.986c-0.567-0.796-1.3-1.543-2.308-2.351c-3.914-3.131-4.757-6.277-4.862-6.738V5 c0-0.553-0.447-1-1-1s-1,0.447-1,1v1v8.359v9.053h-3.706c-3.882,0-6.294,1.961-6.294,5.117c0,3.466,2.24,5.706,5.706,5.706 c3.471,0,6.294-2.823,6.294-6.294V16.468l0.298,0.243c0.34,0.336,0.861,0.72,1.521,1.205c2.318,1.709,6.2,4.567,5.224,7.793 C35.514,25.807,35.5,25.904,35.5,26c0,0.43,0.278,0.826,0.71,0.957C36.307,26.986,36.404,27,36.5,27c0.43,0,0.826-0.278,0.957-0.71 C39.084,20.915,37.035,16.9,35.67,14.986z M26.5,27.941c0,2.368-1.926,4.294-4.294,4.294c-2.355,0-3.706-1.351-3.706-3.706 c0-2.576,2.335-3.117,4.294-3.117H26.5V27.941z M31.505,16.308c-0.571-0.422-1.065-0.785-1.371-1.081l-1.634-1.34v-3.473 c0.827,1.174,1.987,2.483,3.612,3.783c0.858,0.688,1.472,1.308,1.929,1.95c0.716,1.003,1.431,2.339,1.788,3.978 C34.502,18.515,32.745,17.221,31.505,16.308z"
      />
    </g>
    <g
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.75px',
        fontFamily: 'Allerta',
        fill: '#fff',
        fillOpacity: 1,
      }}
    >
      <path d="m 24.320801,42.525024 -2.672119,9.949952 -2.094727,0 -1.624756,-7.465821 -1.732178,7.465821 -2.108154,0 -2.510986,-9.949952 1.826172,0 1.745605,8.540039 1.879883,-8.540039 1.826172,0 1.745605,8.540039 1.893311,-8.540039 1.826172,0 z" />
      <path d="m 25.86499,52.421265 3.464356,-9.882813 1.5979,0 3.4375,9.882813 -1.665039,0 -0.71167,-2.054444 -3.719482,0 -0.725098,2.054444 -1.678467,0 z m 2.779541,-3.14209 2.954102,0 -1.463623,-4.27002 -1.490479,4.27002 z" />
      <path d="m 39.104736,52.474976 -3.074951,-9.949952 1.8396,0 2.296142,8.540039 2.43042,-8.540039 1.826172,0 -3.222656,9.949952 -2.094727,0 z" />
    </g>
  </IconWrapper>
)

const WmaFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#95a5a5', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M35.67,14.986c-0.567-0.796-1.3-1.543-2.308-2.351c-3.914-3.131-4.757-6.277-4.862-6.738V5 c0-0.553-0.447-1-1-1s-1,0.447-1,1v1v8.359v9.053h-3.706c-3.882,0-6.294,1.961-6.294,5.117c0,3.466,2.24,5.706,5.706,5.706 c3.471,0,6.294-2.823,6.294-6.294V16.468l0.298,0.243c0.34,0.336,0.861,0.72,1.521,1.205c2.318,1.709,6.2,4.567,5.224,7.793 C35.514,25.807,35.5,25.904,35.5,26c0,0.43,0.278,0.826,0.71,0.957C36.307,26.986,36.404,27,36.5,27c0.43,0,0.826-0.278,0.957-0.71 C39.084,20.915,37.035,16.9,35.67,14.986z M26.5,27.941c0,2.368-1.926,4.294-4.294,4.294c-2.355,0-3.706-1.351-3.706-3.706 c0-2.576,2.335-3.117,4.294-3.117H26.5V27.941z M31.505,16.308c-0.571-0.422-1.065-0.785-1.371-1.081l-1.634-1.34v-3.473 c0.827,1.174,1.987,2.483,3.612,3.783c0.858,0.688,1.472,1.308,1.929,1.95c0.716,1.003,1.431,2.339,1.788,3.978 C34.502,18.515,32.745,17.221,31.505,16.308z"
      />
    </g>
    <g
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.75px',
        fontFamily: 'Allerta',
        fill: '#fff',
        fillOpacity: 1,
      }}
    >
      <path d="m 23.401001,42.525024 -2.672119,9.949952 -2.094727,0 -1.624756,-7.465821 -1.732177,7.465821 -2.108155,0 -2.510986,-9.949952 1.826172,0 1.745605,8.540039 1.879883,-8.540039 1.826172,0 1.745606,8.540039 1.89331,-8.540039 1.826172,0 z" />
      <path d="m 33.109253,42.525024 1.638184,0 0,9.896241 -1.638184,0 0,-6.807862 -2.215576,5.505371 -1.42334,0 -2.229004,-5.505371 0,6.807862 -1.638184,0 0,-9.896241 1.638184,0 2.940674,6.767579 2.927246,-6.767579 z" />
      <path d="m 36.842163,52.421265 3.464356,-9.882813 1.5979,0 3.4375,9.882813 -1.665039,0 -0.71167,-2.054444 -3.719482,0 -0.725098,2.054444 -1.678467,0 z m 2.779541,-3.14209 2.954102,0 -1.463623,-4.27002 -1.490479,4.27002 z" />
    </g>
  </IconWrapper>
)

const FlacFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#90bae1', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M35.67,14.986c-0.567-0.796-1.3-1.543-2.308-2.351c-3.914-3.131-4.757-6.277-4.862-6.738V5 c0-0.553-0.447-1-1-1s-1,0.447-1,1v1v8.359v9.053h-3.706c-3.882,0-6.294,1.961-6.294,5.117c0,3.466,2.24,5.706,5.706,5.706 c3.471,0,6.294-2.823,6.294-6.294V16.468l0.298,0.243c0.34,0.336,0.861,0.72,1.521,1.205c2.318,1.709,6.2,4.567,5.224,7.793 C35.514,25.807,35.5,25.904,35.5,26c0,0.43,0.278,0.826,0.71,0.957C36.307,26.986,36.404,27,36.5,27c0.43,0,0.826-0.278,0.957-0.71 C39.084,20.915,37.035,16.9,35.67,14.986z M26.5,27.941c0,2.368-1.926,4.294-4.294,4.294c-2.355,0-3.706-1.351-3.706-3.706 c0-2.576,2.335-3.117,4.294-3.117H26.5V27.941z M31.505,16.308c-0.571-0.422-1.065-0.785-1.371-1.081l-1.634-1.34v-3.473 c0.827,1.174,1.987,2.483,3.612,3.783c0.858,0.688,1.472,1.308,1.929,1.95c0.716,1.003,1.431,2.339,1.788,3.978 C34.502,18.515,32.745,17.221,31.505,16.308z"
      />
    </g>
    <g
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.75px',
        fontFamily: 'Allerta',
        fill: '#fff',
        fillOpacity: 1,
      }}
    >
      <path d="m 13.310059,43.820801 0,3.115234 4.135742,0 0,1.101074 -4.135742,0 0,4.458008 -1.638184,0 0,-9.89624 6.190186,0 0,1.221924 -4.552002,0 z" />
      <path d="m 21.232422,42.598877 0,8.674316 4.552002,0 0,1.221924 -6.190186,0 0,-9.89624 1.638184,0 z" />
      <path d="m 27.033203,52.495117 3.464356,-9.882812 1.5979,0 3.4375,9.882812 -1.665039,0 -0.71167,-2.054443 -3.719482,0 -0.725098,2.054443 -1.678467,0 z m 2.779541,-3.14209 2.954102,0 -1.463623,-4.270019 -1.490479,4.270019 z" />
      <path d="m 44.328125,51.488037 q -0.550537,0.537109 -1.248779,0.805664 -0.698242,0.268555 -1.503907,0.268555 -0.88623,0 -1.638183,-0.322266 Q 39.19873,51.917725 38.634766,51.286621 38.084229,50.655518 37.761963,49.702148 37.453125,48.748779 37.453125,47.5 q 0,-1.248779 0.308838,-2.188721 0.322266,-0.953369 0.872803,-1.584472 0.563964,-0.631104 1.315918,-0.95337 0.751953,-0.335693 1.624755,-0.335693 0.805665,0 1.503907,0.268555 0.698242,0.268555 1.248779,0.805664 l -1.114502,0.993652 Q 42.87793,44.116211 42.46167,43.94165 q -0.402832,-0.17456 -0.845947,-0.17456 -0.496827,0 -0.953369,0.187988 -0.443116,0.187988 -0.805665,0.644531 -0.349121,0.443116 -0.550537,1.154786 -0.201416,0.711669 -0.214843,1.745605 0.01343,1.00708 0.201416,1.71875 0.201416,0.71167 0.537109,1.168213 0.349121,0.443115 0.778809,0.657959 0.443115,0.201416 0.926513,0.201416 0.483399,0 0.899658,-0.174561 0.429688,-0.17456 0.778809,-0.563965 l 1.114502,0.980225 z" />
    </g>
  </IconWrapper>
)

const AacFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#e57e25', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M35.67,14.986c-0.567-0.796-1.3-1.543-2.308-2.351c-3.914-3.131-4.757-6.277-4.862-6.738V5 c0-0.553-0.447-1-1-1s-1,0.447-1,1v1v8.359v9.053h-3.706c-3.882,0-6.294,1.961-6.294,5.117c0,3.466,2.24,5.706,5.706,5.706 c3.471,0,6.294-2.823,6.294-6.294V16.468l0.298,0.243c0.34,0.336,0.861,0.72,1.521,1.205c2.318,1.709,6.2,4.567,5.224,7.793 C35.514,25.807,35.5,25.904,35.5,26c0,0.43,0.278,0.826,0.71,0.957C36.307,26.986,36.404,27,36.5,27c0.43,0,0.826-0.278,0.957-0.71 C39.084,20.915,37.035,16.9,35.67,14.986z M26.5,27.941c0,2.368-1.926,4.294-4.294,4.294c-2.355,0-3.706-1.351-3.706-3.706 c0-2.576,2.335-3.117,4.294-3.117H26.5V27.941z M31.505,16.308c-0.571-0.422-1.065-0.785-1.371-1.081l-1.634-1.34v-3.473 c0.827,1.174,1.987,2.483,3.612,3.783c0.858,0.688,1.472,1.308,1.929,1.95c0.716,1.003,1.431,2.339,1.788,3.978 C34.502,18.515,32.745,17.221,31.505,16.308z"
      />
    </g>
    <g
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.75px',
        fontFamily: 'Allerta',
        fill: '#fff',
        fillOpacity: 1,
      }}
    >
      <path d="m 14.25,52.495117 3.464355,-9.882812 1.597901,0 3.4375,9.882812 -1.665039,0 -0.71167,-2.054443 -3.719483,0 -0.725097,2.054443 -1.678467,0 z m 2.779541,-3.14209 2.954102,0 -1.463623,-4.270019 -1.490479,4.270019 z" />
      <path d="m 24.455078,52.495117 3.464356,-9.882812 1.5979,0 3.4375,9.882812 -1.665039,0 -0.71167,-2.054443 -3.719482,0 -0.725098,2.054443 -1.678467,0 z m 2.779541,-3.14209 2.954102,0 -1.463623,-4.270019 -1.490479,4.270019 z" />
      <path d="m 41.75,51.488037 q -0.550537,0.537109 -1.248779,0.805664 -0.698242,0.268555 -1.503907,0.268555 -0.88623,0 -1.638183,-0.322266 -0.738526,-0.322265 -1.30249,-0.953369 Q 35.506104,50.655518 35.183838,49.702148 34.875,48.748779 34.875,47.5 q 0,-1.248779 0.308838,-2.188721 0.322266,-0.953369 0.872803,-1.584472 0.563964,-0.631104 1.315918,-0.95337 0.751953,-0.335693 1.624755,-0.335693 0.805665,0 1.503907,0.268555 0.698242,0.268555 1.248779,0.805664 l -1.114502,0.993652 q -0.335693,-0.389404 -0.751953,-0.563965 -0.402832,-0.17456 -0.845947,-0.17456 -0.496827,0 -0.953369,0.187988 -0.443116,0.187988 -0.805665,0.644531 -0.349121,0.443116 -0.550537,1.154786 -0.201416,0.711669 -0.214843,1.745605 0.01343,1.00708 0.201416,1.71875 0.201416,0.71167 0.537109,1.168213 0.349121,0.443115 0.778809,0.657959 0.443115,0.201416 0.926513,0.201416 0.483399,0 0.899658,-0.174561 0.429688,-0.17456 0.778809,-0.563965 L 41.75,51.488037 Z" />
    </g>
  </IconWrapper>
)

const Mp4FileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <path
        style={{ fill: '#ff5364' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M22.4,42.924h1.668V53H22.4v-6.932l-2.256,5.605h-1.449l-2.27-5.605V53h-1.668V42.924h1.668 l2.994,6.891L22.4,42.924z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M28.211,53H26.57V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656 s-0.921,0.232-1.449,0.232h-1.217V53z M28.211,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567 c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198H28.211z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M38.479,50.648h-4.361V49.35l4.361-6.426h1.668v6.426h1.053v1.299h-1.053V53h-1.668V50.648z M38.479,49.35v-4.512L35.58,49.35H38.479z"
        />
      </g>
      <path
        style={{ fill: '#c8bdb8' }}
        d="M24.5,28c-0.166,0-0.331-0.041-0.481-0.123C23.699,27.701,23.5,27.365,23.5,27V13 c0-0.365,0.199-0.701,0.519-0.877c0.321-0.175,0.71-0.162,1.019,0.033l11,7C36.325,19.34,36.5,19.658,36.5,20 s-0.175,0.66-0.463,0.844l-11,7C24.874,27.947,24.687,28,24.5,28z M25.5,14.821v10.357L33.637,20L25.5,14.821z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M28.5,35c-8.271,0-15-6.729-15-15s6.729-15,15-15s15,6.729,15,15S36.771,35,28.5,35z M28.5,7 c-7.168,0-13,5.832-13,13s5.832,13,13,13s13-5.832,13-13S35.668,7,28.5,7z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
    </g>
  </IconWrapper>
)

const Mp3FileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#7d6599' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M35.67,14.986c-0.567-0.796-1.3-1.543-2.308-2.351c-3.914-3.131-4.757-6.277-4.862-6.738V5 c0-0.553-0.447-1-1-1s-1,0.447-1,1v1v8.359v9.053h-3.706c-3.882,0-6.294,1.961-6.294,5.117c0,3.466,2.24,5.706,5.706,5.706 c3.471,0,6.294-2.823,6.294-6.294V16.468l0.298,0.243c0.34,0.336,0.861,0.72,1.521,1.205c2.318,1.709,6.2,4.567,5.224,7.793 C35.514,25.807,35.5,25.904,35.5,26c0,0.43,0.278,0.826,0.71,0.957C36.307,26.986,36.404,27,36.5,27c0.43,0,0.826-0.278,0.957-0.71 C39.084,20.915,37.035,16.9,35.67,14.986z M26.5,27.941c0,2.368-1.926,4.294-4.294,4.294c-2.355,0-3.706-1.351-3.706-3.706 c0-2.576,2.335-3.117,4.294-3.117H26.5V27.941z M31.505,16.308c-0.571-0.422-1.065-0.785-1.371-1.081l-1.634-1.34v-3.473 c0.827,1.174,1.987,2.483,3.612,3.783c0.858,0.688,1.472,1.308,1.929,1.95c0.716,1.003,1.431,2.339,1.788,3.978 C34.502,18.515,32.745,17.221,31.505,16.308z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M22.4,42.924h1.668V53H22.4v-6.932l-2.256,5.605h-1.449l-2.27-5.605V53h-1.668V42.924h1.668 l2.994,6.891L22.4,42.924z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M28.211,53H26.57V42.924h2.898c0.429,0,0.853,0.068,1.271,0.205s0.795,0.342,1.128,0.615 s0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306c0,0.511-0.087,0.973-0.26,1.388s-0.415,0.764-0.725,1.046 s-0.684,0.501-1.121,0.656s-0.921,0.232-1.449,0.232h-1.217V53z M28.211,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 s0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649s0.15-0.622,0.15-1.032c0-0.164-0.022-0.354-0.068-0.567s-0.139-0.419-0.28-0.615 s-0.34-0.36-0.595-0.492s-0.593-0.198-1.012-0.198H28.211z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M38.615,47.695c0.21,0.027,0.426,0.096,0.649,0.205s0.431,0.265,0.622,0.465 s0.351,0.444,0.479,0.731s0.191,0.617,0.191,0.991c0,0.456-0.066,0.85-0.198,1.183s-0.299,0.608-0.499,0.827 s-0.426,0.395-0.677,0.526s-0.494,0.23-0.731,0.294s-0.453,0.104-0.649,0.123s-0.349,0.027-0.458,0.027 c-0.766,0-1.369-0.053-1.812-0.157s-0.75-0.212-0.923-0.321l0.369-1.176c0.082,0.046,0.159,0.096,0.232,0.15 s0.178,0.107,0.314,0.157s0.328,0.091,0.574,0.123s0.583,0.048,1.012,0.048c0.629,0,1.099-0.171,1.408-0.513 s0.465-0.772,0.465-1.292c0-0.492-0.142-0.907-0.424-1.244s-0.697-0.506-1.244-0.506h-1.395h0.014l-0.014-1.107h0.93 c0.2,0,0.403-0.005,0.608-0.014s0.398-0.06,0.581-0.15s0.333-0.246,0.451-0.465s0.178-0.533,0.178-0.943 c0-0.164-0.014-0.337-0.041-0.52s-0.103-0.351-0.226-0.506s-0.303-0.28-0.54-0.376s-0.565-0.144-0.984-0.144 s-0.754,0.039-1.005,0.116s-0.439,0.139-0.567,0.185l-0.479-1.23c0.219-0.063,0.49-0.132,0.813-0.205s0.791-0.109,1.401-0.109 c0.429,0,0.834,0.053,1.217,0.157s0.718,0.271,1.005,0.499s0.515,0.52,0.684,0.875s0.253,0.774,0.253,1.258 c0,0.282-0.05,0.54-0.15,0.772s-0.228,0.436-0.383,0.608s-0.328,0.316-0.52,0.431S38.779,47.659,38.615,47.695z"
        />
      </g>
    </g>
  </IconWrapper>
)

const Mp2FileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#9777a8', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M35.67,14.986c-0.567-0.796-1.3-1.543-2.308-2.351c-3.914-3.131-4.757-6.277-4.862-6.738V5 c0-0.553-0.447-1-1-1s-1,0.447-1,1v1v8.359v9.053h-3.706c-3.882,0-6.294,1.961-6.294,5.117c0,3.466,2.24,5.706,5.706,5.706 c3.471,0,6.294-2.823,6.294-6.294V16.468l0.298,0.243c0.34,0.336,0.861,0.72,1.521,1.205c2.318,1.709,6.2,4.567,5.224,7.793 C35.514,25.807,35.5,25.904,35.5,26c0,0.43,0.278,0.826,0.71,0.957C36.307,26.986,36.404,27,36.5,27c0.43,0,0.826-0.278,0.957-0.71 C39.084,20.915,37.035,16.9,35.67,14.986z M26.5,27.941c0,2.368-1.926,4.294-4.294,4.294c-2.355,0-3.706-1.351-3.706-3.706 c0-2.576,2.335-3.117,4.294-3.117H26.5V27.941z M31.505,16.308c-0.571-0.422-1.065-0.785-1.371-1.081l-1.634-1.34v-3.473 c0.827,1.174,1.987,2.483,3.612,3.783c0.858,0.688,1.472,1.308,1.929,1.95c0.716,1.003,1.431,2.339,1.788,3.978 C34.502,18.515,32.745,17.221,31.505,16.308z"
      />
    </g>
    <g
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.75px',
        fontFamily: 'Allerta',
        fill: '#fff',
        fillOpacity: 1,
      }}
    >
      <path d="m 22.581909,42.585449 1.638184,0 0,9.89624 -1.638184,0 0,-6.807861 -2.215576,5.505371 -1.42334,0 -2.229004,-5.505371 0,6.807861 -1.638183,0 0,-9.89624 1.638183,0 2.940674,6.767578 2.927246,-6.767578 z" />
      <path d="m 28.302124,52.481689 -1.611328,0 0,-9.89624 2.84668,0 q 0.631103,0 1.248779,0.201416 0.617676,0.201416 1.101074,0.604248 0.496826,0.402832 0.792236,0.980225 0.308838,0.563965 0.308838,1.275635 0,0.751953 -0.255127,1.369629 -0.255127,0.604248 -0.71167,1.020507 -0.456543,0.41626 -1.101074,0.644532 -0.644531,0.228271 -1.42334,0.228271 l -1.195068,0 0,3.571777 z m 0,-8.674316 0,3.920898 1.477051,0 q 0.29541,0 0.577392,-0.09399 0.295411,-0.107422 0.53711,-0.335693 0.241699,-0.228272 0.389404,-0.631104 0.147705,-0.416259 0.147705,-1.020507 0,-0.2417 -0.06714,-0.550537 -0.06714,-0.322266 -0.281982,-0.604249 -0.201416,-0.29541 -0.577393,-0.483398 -0.375976,-0.201416 -0.993652,-0.201416 l -1.208496,0 z" />
      <path d="m 40.776489,45.526123 q 0,0.523682 -0.228271,1.087647 -0.228272,0.550537 -0.604248,1.101074 -0.375977,0.537109 -0.83252,1.047363 -0.443115,0.510254 -0.899658,0.966797 -0.443115,0.456543 -0.845947,0.832519 -0.389405,0.362549 -0.644532,0.617676 l 4.202881,0 0,1.30249 -6.149902,0 0,-1.503906 q 0.241699,-0.214844 0.671387,-0.577392 0.429687,-0.375977 0.926513,-0.83252 0.496827,-0.456543 0.993653,-0.966797 0.496826,-0.523681 0.899658,-1.047363 0.41626,-0.537109 0.671387,-1.047363 0.268554,-0.510254 0.268554,-0.966797 0,-0.469971 -0.17456,-0.778809 -0.161133,-0.322265 -0.41626,-0.523681 -0.255127,-0.201416 -0.563965,-0.281983 -0.29541,-0.08057 -0.563965,-0.08057 -0.523681,0 -0.872802,0.04028 -0.335694,0.02686 -0.590821,0.09399 -0.255127,0.05371 -0.456543,0.161133 -0.201416,0.107422 -0.429687,0.241699 L 34.66687,43.417969 q 0.241699,-0.214844 0.59082,-0.389405 0.362549,-0.17456 0.738526,-0.281982 0.389404,-0.107422 0.765381,-0.161133 0.375976,-0.06714 0.698242,-0.06714 0.872803,0 1.490478,0.281982 0.631104,0.281982 1.033936,0.725098 0.402832,0.429687 0.59082,0.966796 0.201416,0.53711 0.201416,1.033936 z" />
    </g>
  </IconWrapper>
)

const FlaFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#ce3c3b' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M17.246,44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924h6.303v1.244H17.246z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M25.299,42.924v8.832h4.635V53h-6.303V42.924H25.299z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M31.205,53l3.527-10.063h1.627L39.859,53h-1.695l-0.725-2.092h-3.787L32.914,53H31.205z M34.035,49.801h3.008l-1.49-4.348L34.035,49.801z"
        />
      </g>
      <circle style={{ fill: '#c8bdb8' }} cx="25.5" cy="16" r="2" />
      <g>
        <path
          style={{ fill: '#c8bdb8' }}
          d="M34.985,13.929l-0.707-0.707C32.201,11.144,29.438,10,26.5,10s-5.701,1.144-7.778,3.222 C16.644,15.299,15.5,18.062,15.5,21s1.144,5.701,3.222,7.778C20.799,30.856,23.562,32,26.5,32s5.701-1.144,7.778-3.222 l0.707-0.707L27.914,21L34.985,13.929z M32.118,28.032C30.528,29.308,28.567,30,26.5,30c-2.404,0-4.664-0.936-6.364-2.636 S17.5,23.404,17.5,21s0.936-4.664,2.636-6.364S24.096,12,26.5,12c2.067,0,4.028,0.692,5.618,1.968L25.086,21L32.118,28.032z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M35.5,20h-3c-0.553,0-1,0.447-1,1s0.447,1,1,1h3c0.553,0,1-0.447,1-1S36.053,20,35.5,20z"
        />
        <path
          style={{ fill: '#c8bdb8' }}
          d="M41.5,20h-2c-0.553,0-1,0.447-1,1s0.447,1,1,1h2c0.553,0,1-0.447,1-1S42.053,20,41.5,20z"
        />
      </g>
    </g>
  </IconWrapper>
)

const AviFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#d75e72' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M16.361,53l3.527-10.063h1.627L25.016,53H23.32l-0.725-2.092h-3.787L18.07,53H16.361z M19.191,49.801h3.008l-1.49-4.348L19.191,49.801z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M29.828,53.055l-3.131-10.131h1.873l2.338,8.695l2.475-8.695h1.859l-3.281,10.131H29.828z"
        />
        <path style={{ fill: '#fff' }} d="M38.988,53H37.32V42.924h1.668V53z" />
      </g>
      <polygon
        style={{ fill: '#c8bdb8' }}
        points="23.5,28 23.5,20.954 23.5,14 34.5,21"
      />
    </g>
  </IconWrapper>
)

const DwgFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#8697cb' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M19.947,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937 s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C15.95,52.984,15.754,53,15.627,53h-3.814V42.924h3.035 c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C19.842,46.494,19.947,47.08,19.947,47.682z M15.08,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244 c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H15.08z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M35,42.924l-2.721,10.131h-2.133l-1.654-7.602l-1.764,7.602h-2.146l-2.557-10.131h1.859 l1.777,8.695l1.914-8.695h1.859l1.777,8.695l1.928-8.695H35z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M44.57,47.805v3.896c-0.21,0.265-0.444,0.48-0.704,0.649s-0.533,0.308-0.82,0.417 S42.463,52.954,42.157,53s-0.608,0.068-0.909,0.068c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971 c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235 c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.822-0.754,1.333-0.978s1.062-0.335,1.654-0.335 c0.547,0,1.058,0.091,1.531,0.273s0.897,0.456,1.271,0.82l-1.135,1.012c-0.219-0.265-0.47-0.456-0.752-0.574 s-0.574-0.178-0.875-0.178c-0.337,0-0.658,0.063-0.964,0.191s-0.579,0.344-0.82,0.649s-0.431,0.699-0.567,1.183 c-0.137,0.483-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.276,0.212,1.777c0.132,0.501,0.314,0.911,0.547,1.23 s0.497,0.556,0.793,0.711s0.608,0.232,0.937,0.232c0.101,0,0.234-0.007,0.403-0.021s0.337-0.036,0.506-0.068 s0.33-0.075,0.485-0.13s0.269-0.132,0.342-0.232v-2.488h-1.709v-1.121H44.57z"
        />
      </g>
      <rect
        x="12.5"
        y="13"
        style={{ fill: '#c8bdb8' }}
        width="15"
        height="15.065"
      />
      <rect x="34.5" y="14" style={{ fill: '#ada29e' }} width="2" height="7" />
      <rect x="34.5" y="29" style={{ fill: '#ada29e' }} width="2" height="7" />
      <path
        style={{ fill: '#ada29e' }}
        d="M40.5,30h-10V20h10V30z M32.5,28h6v-6h-6V28z"
      />
      <rect x="39.5" y="24" style={{ fill: '#ada29e' }} width="7" height="2" />
      <rect x="24.5" y="24" style={{ fill: '#ada29e' }} width="7" height="2" />
    </g>
  </IconWrapper>
)

const PsdFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <path
        style={{ fill: '#5889c4' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M17.385,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656 s-0.921,0.232-1.449,0.232h-1.217V53z M17.385,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032 c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492 c-0.255-0.132-0.593-0.198-1.012-0.198H17.385z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M29.73,50.238c0,0.364-0.075,0.718-0.226,1.06s-0.362,0.643-0.636,0.902s-0.611,0.467-1.012,0.622 c-0.401,0.155-0.857,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116 c-0.237-0.055-0.463-0.13-0.677-0.226c-0.214-0.096-0.399-0.212-0.554-0.349l0.287-1.176c0.127,0.073,0.289,0.144,0.485,0.212 c0.196,0.068,0.398,0.132,0.608,0.191c0.209,0.06,0.419,0.107,0.629,0.144c0.209,0.036,0.405,0.055,0.588,0.055 c0.556,0,0.982-0.13,1.278-0.39c0.296-0.26,0.444-0.645,0.444-1.155c0-0.31-0.105-0.574-0.314-0.793 c-0.21-0.219-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533c-0.365-0.178-0.707-0.388-1.025-0.629 c-0.319-0.241-0.583-0.526-0.793-0.854c-0.21-0.328-0.314-0.738-0.314-1.23c0-0.446,0.082-0.843,0.246-1.189 s0.385-0.641,0.663-0.882c0.278-0.241,0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191c0.419,0,0.843,0.039,1.271,0.116 c0.428,0.077,0.774,0.203,1.039,0.376c-0.055,0.118-0.119,0.248-0.191,0.39c-0.073,0.142-0.142,0.273-0.205,0.396 c-0.064,0.123-0.119,0.226-0.164,0.308c-0.046,0.082-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109 s-0.167-0.091-0.294-0.137c-0.128-0.046-0.296-0.077-0.506-0.096c-0.21-0.019-0.479-0.014-0.807,0.014 c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321c-0.128,0.128-0.228,0.271-0.301,0.431 c-0.073,0.159-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882c0.209,0.224,0.469,0.419,0.779,0.588 c0.31,0.169,0.647,0.333,1.012,0.492c0.364,0.159,0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854 C29.625,49.261,29.73,49.7,29.73,50.238z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M39.629,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937 s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C35.632,52.984,35.436,53,35.309,53h-3.814V42.924h3.035 c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C39.524,46.494,39.629,47.08,39.629,47.682z M34.762,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244 c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H34.762z"
        />
      </g>
      <path
        style={{ fill: '#c8bdb8' }}
        d="M38.894,11.163c-0.463-0.301-1.082-0.171-1.384,0.291c-1.433,2.196-3.979,5.164-5.19,6.375 l-2.788,2.788l-2.828-2.828L29.49,15c1.771-1.771,6.271-5.442,8.116-6.102c0.04-0.006,0.091-0.015,0.112-0.02 c0.521-0.117,0.827-0.617,0.735-1.143c-0.093-0.526-0.616-0.885-1.143-0.814l-0.283,0.062c-2.439,0.813-7.457,5.108-8.952,6.604 l-7.185,7.185c-0.095-0.004-0.189-0.014-0.285-0.014c-2.971,0-5.463,2.125-5.983,5.016l-0.108,0.073l-0.02,0.536 c-0.034,0.942-0.302,4.052-2.343,4.546c-0.517,0.129-0.858,0.625-0.793,1.152L11.52,33h6.98l0.02,0v0l2.086-0.03 c3.367,0,6.107-2.74,6.107-6.107c0-0.193-0.011-0.383-0.029-0.572l7.049-7.048c1.305-1.305,3.925-4.358,5.451-6.696 C39.486,12.084,39.356,11.465,38.894,11.163z M20.606,30.97h-3.739L16.882,31h-1.661c0.887-1.341,1.161-3.037,1.244-4.045 l0.082-0.504c0.213-2.106,1.958-3.694,4.06-3.694c0.121,0,0.235,0.025,0.354,0.036l0.167,0.021c1.045,0.134,1.956,0.655,2.6,1.411 c0.058,0.069,0.118,0.135,0.171,0.208c0.082,0.11,0.155,0.227,0.226,0.345c0.05,0.085,0.097,0.172,0.142,0.26 c0.063,0.126,0.124,0.254,0.174,0.387c0.03,0.08,0.052,0.164,0.077,0.247c0.045,0.147,0.091,0.294,0.12,0.449l0.005,0.026 c0.041,0.234,0.072,0.471,0.072,0.716C24.713,29.127,22.871,30.97,20.606,30.97z M25.516,23.247 c-0.007-0.009-0.013-0.017-0.02-0.026c-0.605-0.811-1.405-1.465-2.332-1.895l2.123-2.123l2.828,2.828l-2.071,2.07 C25.893,23.801,25.715,23.516,25.516,23.247z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
    </g>
  </IconWrapper>
)

const AiFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <path
        style={{ fill: '#ffc14f' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M20.067,53l3.527-10.063h1.627L28.722,53h-1.695l-0.725-2.092h-3.787L21.776,53H20.067z M22.897,49.801h3.008l-1.49-4.348L22.897,49.801z"
        />
        <path style={{ fill: '#fff' }} d="M32.536,53h-1.668V42.924h1.668V53z" />
      </g>
      <path
        style={{ fill: '#c8bdb8' }}
        d="M37.5,11v0.461c-3.071,0.968-5.503,3.382-6.502,6.44C30.311,17.346,29.45,17,28.5,17 c-1.859,0-3.411,1.28-3.858,3H21.5v-2h-6v6h6v-2h2.921c-0.336,2.663-1.985,4.978-4.389,6.163C19.364,26.884,18.04,26,16.5,26 c-2.206,0-4,1.794-4,4s1.794,4,4,4c2.146,0,3.888-1.702,3.982-3.825c2.655-1.151,4.647-3.387,5.524-6.073 C26.692,24.655,27.552,25,28.5,25c1.859,0,3.411-1.28,3.858-3H35.5v2h6v-6h-6v2h-2.931c0.379-3.019,2.444-5.514,5.222-6.518 C38.383,14.955,39.818,16,41.5,16c2.206,0,4-1.794,4-4v-1H37.5z M19.5,22h-2v-2h2V22z M16.5,32c-1.103,0-2-0.897-2-2s0.897-2,2-2 s2,0.897,2,2S17.603,32,16.5,32z M37.5,20h2v2h-2V20z M28.5,23c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S29.603,23,28.5,23z M41.5,14c-0.723,0-1.353-0.389-1.704-0.964C40.028,13.015,40.262,13,40.5,13h2.731C42.886,13.597,42.239,14,41.5,14z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
    </g>
  </IconWrapper>
)

const SvgFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#e57e25' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M21.459,50.238c0,0.364-0.075,0.718-0.226,1.06s-0.362,0.643-0.636,0.902s-0.61,0.467-1.012,0.622 s-0.856,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116s-0.463-0.13-0.677-0.226 s-0.398-0.212-0.554-0.349l0.287-1.176c0.128,0.073,0.289,0.144,0.485,0.212s0.398,0.132,0.608,0.191s0.419,0.107,0.629,0.144 s0.405,0.055,0.588,0.055c0.556,0,0.982-0.13,1.278-0.39c0.296-0.26,0.444-0.645,0.444-1.155c0-0.31-0.104-0.574-0.314-0.793 s-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533s-0.706-0.388-1.025-0.629s-0.583-0.526-0.793-0.854s-0.314-0.738-0.314-1.23 c0-0.446,0.082-0.843,0.246-1.189s0.385-0.641,0.663-0.882s0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191 c0.419,0,0.843,0.039,1.271,0.116s0.774,0.203,1.039,0.376c-0.055,0.118-0.118,0.248-0.191,0.39s-0.142,0.273-0.205,0.396 s-0.118,0.226-0.164,0.308s-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109s-0.166-0.091-0.294-0.137 s-0.296-0.077-0.506-0.096s-0.479-0.014-0.807,0.014c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321 s-0.228,0.271-0.301,0.431s-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882s0.47,0.419,0.779,0.588 s0.647,0.333,1.012,0.492s0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854S21.459,49.7,21.459,50.238z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M25.861,53.055L22.73,42.924h1.873l2.338,8.695l2.475-8.695h1.859l-3.281,10.131H25.861z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M40.668,47.805v3.896c-0.21,0.265-0.444,0.48-0.704,0.649s-0.533,0.308-0.82,0.417 S38.561,52.954,38.255,53s-0.608,0.068-0.909,0.068c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971 s-0.675-0.966-0.889-1.613s-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235s0.511-1.178,0.889-1.606s0.822-0.754,1.333-0.978 s1.062-0.335,1.654-0.335c0.547,0,1.058,0.091,1.531,0.273s0.897,0.456,1.271,0.82l-1.135,1.012 c-0.219-0.265-0.47-0.456-0.752-0.574s-0.574-0.178-0.875-0.178c-0.337,0-0.658,0.063-0.964,0.191s-0.579,0.344-0.82,0.649 s-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.276,0.212,1.777s0.314,0.911,0.547,1.23 s0.497,0.556,0.793,0.711s0.608,0.232,0.937,0.232c0.101,0,0.234-0.007,0.403-0.021s0.337-0.036,0.506-0.068 s0.33-0.075,0.485-0.13s0.269-0.132,0.342-0.232v-2.488h-1.709v-1.121H40.668z"
        />
      </g>
      <path
        style={{ fill: '#c8bdb8' }}
        d="M45.5,22v-6h-6v2h-6v-4h-10v4h-6v-2h-6v6h6v-2h3.548c-4.566,2.636-7.548,7.588-7.548,13 c0,0.552,0.447,1,1,1s1-0.448,1-1c0-5.246,3.229-9.999,8-11.995V24h10v-2.995c4.771,1.997,8,6.75,8,11.995c0,0.552,0.447,1,1,1 s1-0.448,1-1c0-5.412-2.982-10.364-7.548-13H39.5v2H45.5z M15.5,20h-2v-2h2V20z M31.5,22h-6v-3.754V16h6v2.246V22z M41.5,18h2v2h-2 V18z"
      />
    </g>
  </IconWrapper>
)

const TiffFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <path
        style={{ fill: '#556080', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <circle style={{ fill: '#f3d55b' }} cx="18.931" cy="14.431" r="4.569" />
      <polygon
        style={{ fill: '#8d97b3', fillOpacity: 1 }}
        points="6.5,39 17.5,39 49.5,39 49.5,28 39.5,18.5 29,30 23.517,24.517"
      />
    </g>
    <g
      xmlns="http://www.w3.org/2000/svg"
      transform="scale(0.99005755,1.0100423)"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.88808155px',
        fontFamily: 'Allerta',
        fill: '#fff',
        fillOpacity: 1,
      }}
    >
      <path
        d="m 21.859303,42.442173 0,1.112131 -2.983768,0 0,8.88349 -1.641072,0 0,-8.88349 -2.983768,0 0,-1.112131 7.608608,0 z"
        style={{ fill: '#fff' }}
      />
      <path
        d="m 25.494074,52.437794 -1.654634,0 0,-9.995621 1.654634,0 0,9.995621 z"
        style={{ fill: '#fff' }}
      />
      <path
        d="m 29.684912,43.676367 0,3.146519 4.177274,0 0,1.112131 -4.177274,0 0,4.502777 -1.654635,0 0,-9.995621 6.252349,0 0,1.234194 -4.597714,0 z"
        style={{ fill: '#fff' }}
      />
      <path
        d="m 37.71396,43.676367 0,3.146519 4.177274,0 0,1.112131 -4.177274,0 0,4.502777 -1.654635,0 0,-9.995621 6.252349,0 0,1.234194 -4.597714,0 z"
        style={{ fill: '#fff' }}
      />
    </g>
  </IconWrapper>
)

const GifFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <path
        style={{ fill: '#e57e25', fillOpacity: 1 }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <circle style={{ fill: '#f3d55b' }} cx="18.931" cy="14.431" r="4.569" />
      <polygon
        style={{ fill: '#f29c1f', fillOpacity: 1 }}
        points="6.5,39 17.5,39 49.5,39 49.5,28 39.5,18.5 29,30 23.517,24.517"
      />
    </g>
    <g
      xmlns="http://www.w3.org/2000/svg"
      transform="scale(0.99024353,1.0098526)"
      style={{
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 400,
        fontStretch: 'normal',
        fontSize: '13.88547325px',
        fontFamily: 'Allerta',
        fill: '#fff',
        fillOpacity: 1,
      }}
    >
      <path
        d="m 25.597767,47.327931 0,3.864609 q -0.311881,0.393241 -0.705122,0.650882 -0.379681,0.24408 -0.813602,0.406801 -0.420361,0.16272 -0.881402,0.23052 -0.447481,0.0678 -0.894962,0.0678 -0.894962,0 -1.654324,-0.325441 -0.745802,-0.325441 -1.315323,-0.962763 -0.555962,-0.637321 -0.881402,-1.600083 -0.311881,-0.962763 -0.311881,-2.223846 0,-1.261083 0.311881,-2.210285 0.32544,-0.962762 0.881402,-1.600084 0.569521,-0.637321 1.328883,-0.962762 0.759362,-0.339001 1.640764,-0.339001 0.813602,0 1.518723,0.271201 0.705122,0.2712 1.261083,0.813602 l -1.125482,1.003442 q -0.325441,-0.393241 -0.745802,-0.569521 -0.420361,-0.176281 -0.867842,-0.176281 -0.501721,0 -0.962762,0.189841 -0.447482,0.18984 -0.813602,0.650881 -0.352561,0.447481 -0.555962,1.166163 -0.2034,0.718682 -0.21696,1.762804 0.01356,1.017003 0.2034,1.762805 0.203401,0.745801 0.542402,1.220402 0.35256,0.474602 0.786481,0.705122 0.447482,0.230521 0.935643,0.230521 0.14916,0 0.393241,-0.01356 0.25764,-0.02712 0.501721,-0.0678 0.25764,-0.05424 0.488161,-0.135601 0.230521,-0.08136 0.339001,-0.23052 l 0,-2.467926 -1.695004,0 0,-1.111923 3.308648,0 z"
        style={{ fill: '#fff' }}
      />
      <path
        d="m 29.625096,52.480743 -1.654324,0 0,-9.993744 1.654324,0 0,9.993744 z"
        style={{ fill: '#fff' }}
      />
      <path
        d="m 33.815146,43.720962 0,3.145928 4.17649,0 0,1.111923 -4.17649,0 0,4.50193 -1.654324,0 0,-9.993744 6.251175,0 0,1.233963 -4.596851,0 z"
        style={{ fill: '#fff' }}
      />
    </g>
  </IconWrapper>
)

const JpgFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <circle style={{ fill: '#f3d55b' }} cx="18.931" cy="14.431" r="4.569" />
      <polygon
        style={{ fill: '#26b99a' }}
        points="6.5,39 17.5,39 49.5,39 49.5,28 39.5,18.5 29,30 23.517,24.517"
      />
      <path
        style={{ fill: '#14a085' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M21.426,42.65v7.848c0,0.474-0.087,0.873-0.26,1.196c-0.173,0.323-0.406,0.583-0.697,0.779 c-0.292,0.196-0.627,0.333-1.005,0.41C19.085,52.961,18.696,53,18.295,53c-0.201,0-0.436-0.021-0.704-0.062 c-0.269-0.041-0.547-0.104-0.834-0.191s-0.563-0.185-0.827-0.294c-0.265-0.109-0.488-0.232-0.67-0.369l0.697-1.107 c0.091,0.063,0.221,0.13,0.39,0.198c0.168,0.068,0.353,0.132,0.554,0.191c0.2,0.06,0.41,0.111,0.629,0.157 s0.424,0.068,0.615,0.068c0.483,0,0.868-0.094,1.155-0.28s0.439-0.504,0.458-0.95V42.65H21.426z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M25.514,52.932h-1.641V42.855h2.898c0.428,0,0.852,0.068,1.271,0.205 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656 s-0.921,0.232-1.449,0.232h-1.217V52.932z M25.514,44.1v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567 c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492C27.5,44.166,27.163,44.1,26.744,44.1H25.514z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M39.5,47.736v3.896c-0.21,0.265-0.444,0.48-0.704,0.649s-0.533,0.308-0.82,0.417 s-0.583,0.187-0.889,0.232C36.781,52.978,36.479,53,36.178,53c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971 c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235 c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335 c0.547,0,1.057,0.091,1.531,0.273c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.219-0.265-0.47-0.456-0.752-0.574 c-0.283-0.118-0.574-0.178-0.875-0.178c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649 c-0.242,0.306-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.276,0.212,1.777 c0.132,0.501,0.314,0.911,0.547,1.23s0.497,0.556,0.793,0.711c0.296,0.155,0.608,0.232,0.937,0.232c0.1,0,0.234-0.007,0.403-0.021 c0.168-0.014,0.337-0.036,0.506-0.068c0.168-0.032,0.33-0.075,0.485-0.13c0.155-0.055,0.269-0.132,0.342-0.232v-2.488h-1.709 v-1.121H39.5z"
        />
      </g>
    </g>
  </IconWrapper>
)

const PngFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <path
        style={{ fill: '#659c35' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <g>
        <path
          style={{ fill: '#fff' }}
          d="M17.385,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656 s-0.921,0.232-1.449,0.232h-1.217V53z M17.385,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103 c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032 c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492 c-0.255-0.132-0.593-0.198-1.012-0.198H17.385z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M31.316,42.924V53h-1.668l-3.951-6.945V53h-1.668V42.924h1.668l3.951,6.945v-6.945H31.316z"
        />
        <path
          style={{ fill: '#fff' }}
          d="M41.16,47.805v3.896c-0.21,0.265-0.444,0.48-0.704,0.649s-0.533,0.308-0.82,0.417 S39.052,52.954,38.747,53c-0.306,0.046-0.608,0.068-0.909,0.068c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971 c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235 c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335 c0.547,0,1.057,0.091,1.531,0.273c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.219-0.265-0.47-0.456-0.752-0.574 c-0.283-0.118-0.574-0.178-0.875-0.178c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649 c-0.242,0.306-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.276,0.212,1.777 c0.132,0.501,0.314,0.911,0.547,1.23s0.497,0.556,0.793,0.711c0.296,0.155,0.608,0.232,0.937,0.232c0.1,0,0.234-0.007,0.403-0.021 c0.168-0.014,0.337-0.036,0.506-0.068c0.168-0.032,0.33-0.075,0.485-0.13c0.155-0.055,0.269-0.132,0.342-0.232v-2.488h-1.709 v-1.121H41.16z"
        />
      </g>
      <circle style={{ fill: '#f3d55b' }} cx="18.931" cy="14.431" r="4.569" />
      <polygon
        style={{ fill: '#88c057' }}
        points="6.5,39 17.5,39 49.5,39 49.5,28 39.5,18.5 29,30 23.517,24.517"
      />
    </g>
  </IconWrapper>
)

const VideoFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M 24.5,40 C 24.334,40 24.169,39.959 24.019,39.877 23.699,39.701 23.5,39.365 23.5,39 l 0,-14 c 0,-0.365 0.199,-0.701 0.519,-0.877 0.321,-0.175 0.71,-0.162 1.019,0.033 l 11,7 C 36.325,31.34 36.5,31.658 36.5,32 c 0,0.342 -0.175,0.66 -0.463,0.844 l -11,7 C 24.874,39.947 24.687,40 24.5,40 Z m 1,-13.179 0,10.357 L 33.637,32 25.5,26.821 Z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="m 28.5,47 c -8.271,0 -15,-6.729 -15,-15 0,-8.271 6.729,-15 15,-15 8.271,0 15,6.729 15,15 0,8.271 -6.729,15 -15,15 z m 0,-28 c -7.168,0 -13,5.832 -13,13 0,7.168 5.832,13 13,13 7.168,0 13,-5.832 13,-13 0,-7.168 -5.832,-13 -13,-13 z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
    </g>
  </IconWrapper>
)

const AudioFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M 35.67,26.986 C 35.103,26.19 34.37,25.443 33.362,24.635 29.448,21.504 28.605,18.358 28.5,17.897 L 28.5,17 c 0,-0.553 -0.447,-1 -1,-1 -0.553,0 -1,0.447 -1,1 l 0,1 0,8.359 0,9.053 -3.706,0 c -3.882,0 -6.294,1.961 -6.294,5.117 0,3.466 2.24,5.706 5.706,5.706 3.471,0 6.294,-2.823 6.294,-6.294 l 0,-11.473 0.298,0.243 c 0.34,0.336 0.861,0.72 1.521,1.205 2.318,1.709 6.2,4.567 5.224,7.793 C 35.514,37.807 35.5,37.904 35.5,38 c 0,0.43 0.278,0.826 0.71,0.957 0.097,0.029 0.194,0.043 0.29,0.043 0.43,0 0.826,-0.278 0.957,-0.71 C 39.084,32.915 37.035,28.9 35.67,26.986 Z M 26.5,39.941 c 0,2.368 -1.926,4.294 -4.294,4.294 -2.355,0 -3.706,-1.351 -3.706,-3.706 0,-2.576 2.335,-3.117 4.294,-3.117 l 3.706,0 0,2.529 z M 31.505,28.308 C 30.934,27.886 30.44,27.523 30.134,27.227 l -1.634,-1.34 0,-3.473 c 0.827,1.174 1.987,2.483 3.612,3.783 0.858,0.688 1.472,1.308 1.929,1.95 0.716,1.003 1.431,2.339 1.788,3.978 -1.327,-1.61 -3.084,-2.904 -4.324,-3.817 z"
      />
    </g>
  </IconWrapper>
)

const ArchiveFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <g>
        <rect
          x="26.5"
          y="42"
          style={{ fill: '#c8bdb8' }}
          width="2"
          height="14"
        />
        <polygon
          style={{ fill: '#c8bdb8' }}
          points="30.5,23 30.5,21 28.5,21 28.5,19 26.5,19 26.5,21 24.5,21 24.5,23 26.5,23 26.5,25 24.5,25 24.5,27 26.5,27 26.5,29 24.5,29 24.5,31 26.5,31 26.5,34 28.5,34 28.5,31 30.5,31 30.5,29 28.5,29 28.5,27 30.5,27 30.5,25 28.5,25 28.5,23"
        />
      </g>
      <g>
        <rect
          x="23.5"
          y="34"
          style={{ fill: '#cbb292' }}
          width="8"
          height="8"
        />
        <path
          style={{ fill: '#5e5f62' }}
          d="M32.5,43h-10V33h10V43z M24.5,41h6v-6h-6V41z"
        />
      </g>
      <rect x="23.5" y="36" style={{ fill: '#5e5f62' }} width="8" height="2" />
    </g>
  </IconWrapper>
)

const TextFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="m 18.5,23 -6,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 6,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="m 21.5,28 -9,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 9,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M 25.5,28 C 25.24,28 24.979,27.89 24.79,27.71 24.609,27.52 24.5,27.27 24.5,27 c 0,-0.27 0.109,-0.52 0.3,-0.71 0.36,-0.37 1.04,-0.37 1.41,0 0.18,0.19 0.29,0.45 0.29,0.71 0,0.26 -0.11,0.52 -0.29,0.71 C 26.02,27.89 25.76,28 25.5,28 Z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="m 37.5,28 -8,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 8,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M 12.5,43 C 12.24,43 11.979,42.89 11.79,42.71 11.609,42.52 11.5,42.26 11.5,42 c 0,-0.26 0.109,-0.52 0.29,-0.71 0.37,-0.37 1.05,-0.37 1.42,0.01 0.18,0.18 0.29,0.44 0.29,0.7 0,0.26 -0.11,0.52 -0.29,0.71 C 13.02,42.89 12.76,43 12.5,43 Z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="m 24.5,43 -8,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 8,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="m 43.5,28 -2,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 2,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="m 34.5,33 -22,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 22,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="m 43.5,33 -6,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 6,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="m 16.5,38 -4,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 4,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="m 30.5,38 -10,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 10,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="m 43.5,38 -9,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 9,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
      />
    </g>
  </IconWrapper>
)

const UnknownFileIcon: FC<IconProps> = props => (
  <IconWrapper {...props}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ fill: '#e9e9e0' }}
        d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      />
      <polygon
        style={{ fill: '#d9d7ca' }}
        points="37.5,0.151 37.5,12 49.349,12"
      />
      <path
        style={{ fill: '#c8bdb8' }}
        d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      />
      <circle style={{ fill: '#fff' }} cx="18.5" cy="47" r="3" />
      <circle style={{ fill: '#fff' }} cx="28.5" cy="47" r="3" />
      <circle style={{ fill: '#fff' }} cx="38.5" cy="47" r="3" />
    </g>
  </IconWrapper>
)

const icons = {
  exe: ExeFileIcon,
  dbf: DbfFileIcon,
  xml: JsFileIcon,
  js: XmlFileIcon,
  json: JsonFileIcon,
  html: HtmlFileIcon,
  csv: CsvFileIcon,
  css: CssFileIcon,
  ppt: PptFileIcon,
  pptx: PptFileIcon,
  xls: XlsFileIcon,
  txt: TxtFileIcon,
  rtf: RtfFileIcon,
  doc: DocFileIcon,
  pdf: PdfFileIcon,
  rar: RarFileIcon,
  arj: ArjFileIcon,
  '7z': Archive7zFileIcon,
  zip: ZipFileIcon,
  nrg: NrgFileIcon,
  mdf: MdfFileIcon,
  iso: IsoFileIcon,
  mxf: MxfFileIcon,
  wav: WavFileIcon,
  wma: WmaFileIcon,
  flac: FlacFileIcon,
  aac: AacFileIcon,
  mp4: Mp4FileIcon,
  mp3: Mp3FileIcon,
  mp2: Mp2FileIcon,
  fla: FlaFileIcon,
  avi: AviFileIcon,
  dwg: DwgFileIcon,
  psd: PsdFileIcon,
  ai: AiFileIcon,
  svg: SvgFileIcon,
  tiff: TiffFileIcon,
  gif: GifFileIcon,
  jpg: JpgFileIcon,
  jpeg: JpgFileIcon,
  jfif: JpgFileIcon,
  png: PngFileIcon,
  video: VideoFileIcon,
  audio: AudioFileIcon,
  archive: ArchiveFileIcon,
  text: TextFileIcon,
}

export const getExtensionIcon = (extension: string) => {
  // For unknown file extensions apply "unknown" icon
  if (icons[extension]) {
    return icons[extension]
  }

  return UnknownFileIcon
}
